import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Router } from '@angular/router';

import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";
import { DatiDocFase1PerImpresa, DatiDocFase2PerImpresa, DatiDocFase3PerImpresa, PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";

@Component({
  selector: "app-home-flowdy2-docs",
  templateUrl: "./home.flowdy2.docs.component.html",
  styleUrls: ["./home.flowdy2.docs.component.css"]
})
export class HomeFlowdy2DocsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;
  @Input() activeTabType?: string; // DOCS_FASE1, DOCS_FASE2, DOCS_FASE3
  @Input() activeBandoNumber?: number; // 1 per Bando 1, 2 per Bando 2

  ref: DynamicDialogRef;

  protected activeFasePanelIndex: number = 0;
  protected activeBandoPanelIndex: number = 0;
  protected filtroRegione: string[] = [];
  protected filterIsSet: boolean = false;
  protected labelRegioni: string = 'Tutte le regioni';

  protected datiRaggruppatiFase1Bando1Filtrati: DatiDocFase1PerImpresa[]          = [];
  protected datiRaggruppatiFase1Bando1:         DatiDocFase1PerImpresa[]          = [];
  protected datiRaggruppatiFase1Bando2Filtrati: DatiDocFase1PerImpresa[]          = [];
  protected datiRaggruppatiFase1Bando2:         DatiDocFase1PerImpresa[]          = [];

  protected datiRaggruppatiFase2Bando1Filtrati: DatiDocFase2PerImpresa[]          = [];
  protected datiRaggruppatiFase2Bando1:         DatiDocFase2PerImpresa[]          = [];
  protected datiRaggruppatiFase2Bando2Filtrati: DatiDocFase2PerImpresa[]          = [];
  protected datiRaggruppatiFase2Bando2:         DatiDocFase2PerImpresa[]          = [];

  protected datiRaggruppatiFase3Bando1Filtrati: DatiDocFase3PerImpresa[]          = [];
  protected datiRaggruppatiFase3Bando1:         DatiDocFase3PerImpresa[]          = [];
  protected datiRaggruppatiFase3Bando2Filtrati: DatiDocFase3PerImpresa[]          = [];
  protected datiRaggruppatiFase3Bando2:         DatiDocFase3PerImpresa[]          = [];

  private collection_pratiche: string = environment.firebase.collection_pratiche;
  //private collectionRef;
  protected isLoading: boolean = false;

  protected totaliFase1Bando1: number = 0;
  protected totaliFase1InAttesaODABando1: number = 0;
  protected totaliFase1DaAssegnareBando1: number = 0;
  protected totaliFase1AssegnateBando1: number = 0;
  protected totaliFase1InCaricoImpresaBando1: number = 0;
  protected totaliFase1SopralluogoPianificatoBando1: number = 0;
  protected totaliFase1SopralluogoEseguitoBando1: number = 0;
  protected totaliFase1SopralluogoKOBando1: number = 0;
  protected totaliFase1PreventivoInAttesaBando1: number = 0;
  protected totaliFase1PreventivoApprovatoBando1: number = 0;
  protected totaliFase1PreventivoRifiutatoBando1: number = 0;
  protected totaliFase1PreventivoKOBando1: number = 0;
  protected totaliFase1ConsegnateBando1: number = 0;
  protected totaliFase1InVerificaSmartfiberBando1: number = 0;
  protected totaliFase1InReworkAziendaBando1: number = 0;
  protected totaliFase1InCaricoPresidioBando1: number = 0;
  protected totaliFase1PubblicateBando1: number = 0;
  protected totaliFase1ApprovateBando1: number = 0;
  protected totaliFase1RespinteBando1: number = 0;
  
  protected totaliFase1Bando2: number = 0;
  protected totaliFase1InAttesaODABando2: number = 0;
  protected totaliFase1DaAssegnareBando2: number = 0;
  protected totaliFase1AssegnateBando2: number = 0;
  protected totaliFase1InCaricoImpresaBando2: number = 0;
  protected totaliFase1SopralluogoPianificatoBando2: number = 0;
  protected totaliFase1SopralluogoEseguitoBando2: number = 0;
  protected totaliFase1SopralluogoKOBando2: number = 0;
  protected totaliFase1PreventivoInAttesaBando2: number = 0;
  protected totaliFase1PreventivoApprovatoBando2: number = 0;
  protected totaliFase1PreventivoRifiutatoBando2: number = 0;
  protected totaliFase1PreventivoKOBando2: number = 0;
  protected totaliFase1ConsegnateBando2: number = 0;
  protected totaliFase1InVerificaSmartfiberBando2: number = 0;
  protected totaliFase1InReworkAziendaBando2: number = 0;
  protected totaliFase1InCaricoPresidioBando2: number = 0;
  protected totaliFase1PubblicateBando2: number = 0;
  protected totaliFase1ApprovateBando2: number = 0;
  protected totaliFase1RespinteBando2: number = 0;
  

  protected totaliFase2Bando1: number = 0;
  protected totaliFase2InAttesaODABando1: number = 0;
  protected totaliFase2DaAssegnareBando1: number = 0;
  protected totaliFase2AssegnateBando1: number = 0;
  protected totaliFase2InCaricoImpresaBando1: number = 0;
  protected totaliFase2AppuntamentoFissatoBando1: number = 0;
  protected totaliFase2AppuntamentoScadutoBando1: number = 0;
  protected totaliFase2InstallazioneOKBando1: number = 0;
  protected totaliFase2AttesaTSBando1: number = 0;
  protected totaliFase2AttivazioneKO_CPEBando1: number = 0;
  protected totaliFase2AttivazioneKO_FOBando1: number = 0;
  protected totaliFase2VerificaTSKO_Bando1: number = 0;
  protected totaliFase2AttivazioneOKBando1: number = 0;
  protected totaliFase2ConsegnateBando1: number = 0;
  protected totaliFase2InVerificaSmartfiberBando1: number = 0;
  protected totaliFase2InReworkAziendaBando1: number = 0;
  protected totaliFase2InCaricoPresidioBando1: number = 0;
  protected totaliFase2PubblicateBando1: number = 0;
  protected totaliFase2ApprovateBando1: number = 0;
  protected totaliFase2RespinteBando1: number = 0;

  protected totaliFase2Bando2: number = 0;
  protected totaliFase2InAttesaODABando2: number = 0;
  protected totaliFase2DaAssegnareBando2: number = 0;
  protected totaliFase2AssegnateBando2: number = 0;
  protected totaliFase2InCaricoImpresaBando2: number = 0;
  protected totaliFase2AppuntamentoFissatoBando2: number = 0;
  protected totaliFase2AppuntamentoScadutoBando2: number = 0;
  protected totaliFase2InstallazioneOKBando2: number = 0;
  protected totaliFase2AttesaTSBando2: number = 0;
  protected totaliFase2AttivazioneKO_CPEBando2: number = 0;
  protected totaliFase2AttivazioneKO_FOBando2: number = 0;
  protected totaliFase2VerificaTSKO_Bando2: number = 0;
  protected totaliFase2AttivazioneOKBando2: number = 0;
  protected totaliFase2ConsegnateBando2: number = 0;
  protected totaliFase2InVerificaSmartfiberBando2: number = 0;
  protected totaliFase2InReworkAziendaBando2: number = 0;
  protected totaliFase2InCaricoPresidioBando2: number = 0;
  protected totaliFase2PubblicateBando2: number = 0;
  protected totaliFase2ApprovateBando2: number = 0;
  protected totaliFase2RespinteBando2: number = 0;

  protected totaliFase3Bando1: number = 0;
  protected totaliFase3InAttesaODABando1: number = 0;
  protected totaliFase3DaAssegnareBando1: number = 0;
  protected totaliFase3AssegnateBando1: number = 0;
  protected totaliFase3InCaricoBando1: number = 0;
  protected totaliFase3InProgettazioneBando1: number = 0;
  protected totaliFase3ConsegnateBando1: number = 0;
  protected totaliFase3InVerificaSmartfiberBando1: number = 0;
  protected totaliFase3InCaricoPresidioBando1: number = 0;
  protected totaliFase3InFirmaBando1: number = 0;
  protected totaliFase3FirmateBando1: number = 0;
  protected totaliFase3PubblicateBando1: number = 0;
  protected totaliFase3ApprovateBando1: number = 0;
  protected totaliFase3RespinteBando1: number = 0;
  protected totaliFase3InReworkAziendaBando1: number = 0;

  protected totaliFase3Bando2: number = 0;
  protected totaliFase3InAttesaODABando2: number = 0;
  protected totaliFase3DaAssegnareBando2: number = 0;
  protected totaliFase3AssegnateBando2: number = 0;
  protected totaliFase3InCaricoBando2: number = 0;
  protected totaliFase3InProgettazioneBando2: number = 0;
  protected totaliFase3ConsegnateBando2: number = 0;
  protected totaliFase3InVerificaSmartfiberBando2: number = 0;
  protected totaliFase3InCaricoPresidioBando2: number = 0;
  protected totaliFase3InFirmaBando2: number = 0;
  protected totaliFase3FirmateBando2: number = 0;
  protected totaliFase3PubblicateBando2: number = 0;
  protected totaliFase3ApprovateBando2: number = 0;
  protected totaliFase3RespinteBando2: number = 0;    
  protected totaliFase3InReworkAziendaBando2: number = 0;

  // Flags per tracciare se i dati sono stati caricati (evita caricamenti multipli)
  private fase1Bando1Loaded: boolean = false;
  private fase1Bando2Loaded: boolean = false;
  private fase2Bando1Loaded: boolean = false;
  private fase2Bando2Loaded: boolean = false;
  private fase3Bando1Loaded: boolean = false;
  private fase3Bando2Loaded: boolean = false;
  
  // Flag per tracciare se è il primo caricamento
  private isFirstLoad: boolean = true;
  
  // Flag per evitare chiamate multiple nello stesso tick
  private isLoadingFase1Bando1: boolean = false;
  private isLoadingFase1Bando2: boolean = false;
  private isLoadingFase2Bando1: boolean = false;
  private isLoadingFase2Bando2: boolean = false;
  private isLoadingFase3Bando1: boolean = false;
  private isLoadingFase3Bando2: boolean = false;

  constructor(
    public auth: AuthService,
    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    public firestore: AngularFirestore,
    public utilService: UtilService,
    public excelService: ExcelService,
    public listeService: ListeService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    // Non caricare nulla qui - lasciare che sia ngAfterViewInit a gestire il caricamento iniziale
    // Questo evita chiamate doppie
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reset dei flag di caricamento all'inizio di ngOnChanges
    this.resetLoadingFlags();
    
    if (changes['impresa'] && changes['impresa'].currentValue) {
      this.impresa = changes['impresa'].currentValue;
    }
    if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
      this.isImpresa = changes['isImpresa'].currentValue;
    }
    if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
      this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
    }

    // Gestisce i cambiamenti dei parametri per i tab (input properties)
    if (changes['activeTabType'] || changes['activeBandoNumber']) {
      this.setActiveTabsFromInputs();
    }

    if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
      // Reset dei flags di caricamento quando cambiano le condizioni utente
      this.resetLoadingFlags();
      
      // Carica solo i dati del tab attivo
      this.loadActiveTabData();
      this.isFirstLoad = false; // Marchia che il primo caricamento è stato fatto
    }
  }

  ngAfterViewInit() {
    // Imposta i tab basandosi sugli input properties se presenti
    let tabsChanged = false;
    
    if (this.activeBandoNumber == 1) {
      this.activeBandoPanelIndex = 0;
      tabsChanged = true;
    } else if (this.activeBandoNumber == 2) {
      this.activeBandoPanelIndex = 1;
      tabsChanged = true;
    }
    
    if (this.activeTabType) {
      switch (this.activeTabType) {
        case 'DOCS_FASE1':
          this.activeFasePanelIndex = 0;
          break;
        case 'DOCS_FASE2':
          this.activeFasePanelIndex = 1;
          break;
        case 'DOCS_FASE3':
          this.activeFasePanelIndex = 2;
          break;
        default:
          this.activeFasePanelIndex = 0;
      }
      tabsChanged = true;
    }
    
    // Carica i dati SOLO se non sono già stati caricati in ngOnChanges
    // e se è il primo caricamento
    if (this.isFirstLoad) {
      this.loadActiveTabData(); // RIMOSSO forceLoad=true per rispettare i flag di caricamento
      this.isFirstLoad = false;
    }
  }

  onFaseTabChange(event: any) {
    this.activeFasePanelIndex = event.index;
    // Usa loadActiveTabData che rispetta i flag di caricamento
    this.loadActiveTabData();
  }

  onBandoTabChange(event: any) {
    this.activeBandoPanelIndex = event.index;
    // Usa loadActiveTabData che rispetta i flag di caricamento
    this.loadActiveTabData();
  }
  
  loadDatiFase1Bando1(){
    if (this.fase1Bando1Loaded || this.isLoadingFase1Bando1) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase1Bando1 = true; // Imposta subito per evitare chiamate multiple
    this.fase1Bando1Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1 = null;
    if(this.isImpresa){
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 E FASE 1 PER IMPRESA " + this.userService.getUser().azienda.id);

      queryBando1 = collectionRef
                  .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 1")
                  .orderBy("codiceStatoInfratelFase1");
    }else{
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 E FASE 1 PER PRESIDIO TIM");
      queryBando1 = collectionRef
      .where("bando", "==", "BANDO 1")
      .orderBy("codiceStatoInfratelFase1");
    }
     

  

   onSnapshot(queryBando1, (qs) => {
      this.isLoading = false;
      this.logger.info("[HOME DOCS] DATI BANDO 1 E FASE 1 ARRIVATI " + qs.docs.length);
      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number;
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          sopralluogoPianificato: number;
          sopralluogoEseguito: number;
          sopralluogoKO: number;
          preventivoInAttesa: number;
          preventivoApprovato: number;
          preventivoRifiutato: number;
          preventivoKO: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
              preventivoInAttesa: number;
              preventivoApprovato: number;
              preventivoRifiutato: number;
              preventivoKO: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
      
    this.resetTotaliFase1Bando1();
      
     qs.forEach((doc) => {
      let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando1DaFirestore.idAziendaFase1? praticaBando1DaFirestore.idAziendaFase1 : praticaBando1DaFirestore.idAzienda;
        const impresa   = praticaBando1DaFirestore.aziendaFase1? praticaBando1DaFirestore.aziendaFase1 : praticaBando1DaFirestore.azienda;
        const regione   = praticaBando1DaFirestore.regione;

            if (!raggruppamentoPerImpresa[impresa]) {
              raggruppamentoPerImpresa[impresa] = { 
                idImpresa: idImpresa,
                totale: 0, 
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0,
                sopralluogoKO :0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
                datiPerRegione: {},
              };
            }
            if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0,
                sopralluogoKO :0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              };
            }
            raggruppamentoPerImpresa[impresa].totale += 1;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;

              
            switch (praticaBando1DaFirestore.statoFlowdyFase1) {
              case 'IN ATTESA ODA':
                raggruppamentoPerImpresa[impresa].inAttesaODA += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA += 1;
                break;
              case 'DA ASSEGNARE':
                raggruppamentoPerImpresa[impresa].daAssegnare += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare += 1;
                break;
              case 'ASSEGNATA':
                raggruppamentoPerImpresa[impresa].assegnate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].assegnate += 1;
                break;
              case 'IN CARICO IMPRESA':
                raggruppamentoPerImpresa[impresa].inCaricoImpresa += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa += 1;
                break;
              case 'SOPRALLUOGO PIANIFICATO':
                raggruppamentoPerImpresa[impresa].sopralluogoPianificato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato += 1;
                break;
              case 'SOPRALLUOGO EFFETTUATO':
                raggruppamentoPerImpresa[impresa].sopralluogoEseguito += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito += 1;
                break;
              case 'SOPRALLUOGO KO':
                raggruppamentoPerImpresa[impresa].sopralluogoKO += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO += 1;
                break;
              case 'PREVENTIVO IN ATTESA':
                raggruppamentoPerImpresa[impresa].preventivoInAttesa += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoInAttesa += 1;
                break;
              case 'PREVENTIVO APPROVATO':
                raggruppamentoPerImpresa[impresa].preventivoApprovato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoApprovato += 1;
                break;
              case 'PREVENTIVO RIFIUTATO':
                raggruppamentoPerImpresa[impresa].preventivoRifiutato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoRifiutato += 1;
                break;
              case 'PREVENTIVO KO':
                raggruppamentoPerImpresa[impresa].preventivoKO += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoKO += 1;
                break;    
              case 'CONSEGNATA':
                raggruppamentoPerImpresa[impresa].consegnate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate += 1;
                break;
              case 'IN VERIFICA SMARTFIBER':
                raggruppamentoPerImpresa[impresa].inVerificaSmartfiber += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber += 1;
                break;
              case 'IN REWORK AZIENDA':
                raggruppamentoPerImpresa[impresa].inReworkAzienda += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda += 1;
                break;
              case 'IN CARICO PRESIDIO':
                raggruppamentoPerImpresa[impresa].inCaricoPresidio += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio += 1;
                break;
              case 'PUBBLICATA':
                raggruppamentoPerImpresa[impresa].pubblicate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate += 1;
                break;
              case 'APPROVATA':
                raggruppamentoPerImpresa[impresa].approvate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate += 1;
                break;
              case 'RESPINTA':
                raggruppamentoPerImpresa[impresa].respinte += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte += 1;
                break;
            }
            this.datiRaggruppatiFase1Bando1 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
              impresa,
              idImpresa:             dati.idImpresa,
              //regione:                dati.regione,
              totale:                 dati.totale,
              inAttesaODA:            dati.inAttesaODA,
              daAssegnare:            dati.daAssegnare,
              assegnate:              dati.assegnate,
              inCaricoImpresa:        dati.inCaricoImpresa,
              sopralluogoPianificato: dati.sopralluogoPianificato,
              sopralluogoEseguito:    dati.sopralluogoEseguito,
              sopralluogoKO:          dati.sopralluogoKO,
              preventivoInAttesa:     dati.preventivoInAttesa,
              preventivoApprovato:    dati.preventivoApprovato,
              preventivoRifiutato:    dati.preventivoRifiutato,
              preventivoKO:           dati.preventivoKO,
              consegnate:             dati.consegnate,
              inVerificaSmartfiber:   dati.inVerificaSmartfiber,
              inReworkAzienda:        dati.inReworkAzienda,
              inCaricoPresidio:       dati.inCaricoPresidio,
              pubblicate:             dati.pubblicate,
              approvate:              dati.approvate,
              respinte:               dati.respinte,
              datiPerRegione:         dati.datiPerRegione,
            }));
            this.datiRaggruppatiFase1Bando1Filtrati = this.datiRaggruppatiFase1Bando1.sort((a, b) => a.impresa.localeCompare(b.impresa));
  
           
      
     });


     
     for (let index = 0; index < this.datiRaggruppatiFase1Bando1.length; index++) {
      this.totaliFase1Bando1                       += this.datiRaggruppatiFase1Bando1[index].totale;
      this.totaliFase1InAttesaODABando1            += this.datiRaggruppatiFase1Bando1[index].inAttesaODA;
      this.totaliFase1DaAssegnareBando1            += this.datiRaggruppatiFase1Bando1[index].daAssegnare;
      this.totaliFase1AssegnateBando1              += this.datiRaggruppatiFase1Bando1[index].assegnate;
      this.totaliFase1InCaricoImpresaBando1        += this.datiRaggruppatiFase1Bando1[index].inCaricoImpresa;
      this.totaliFase1SopralluogoPianificatoBando1 += this.datiRaggruppatiFase1Bando1[index].sopralluogoPianificato;
      this.totaliFase1SopralluogoEseguitoBando1    += this.datiRaggruppatiFase1Bando1[index].sopralluogoEseguito;
      this.totaliFase1SopralluogoKOBando1          += this.datiRaggruppatiFase1Bando1[index].sopralluogoKO;
      this.totaliFase1PreventivoInAttesaBando1     += this.datiRaggruppatiFase1Bando1[index].preventivoInAttesa;
      this.totaliFase1PreventivoApprovatoBando1    += this.datiRaggruppatiFase1Bando1[index].preventivoApprovato;
      this.totaliFase1PreventivoRifiutatoBando1    += this.datiRaggruppatiFase1Bando1[index].preventivoRifiutato;
      this.totaliFase1PreventivoKOBando1           += this.datiRaggruppatiFase1Bando1[index].preventivoKO;
      this.totaliFase1ConsegnateBando1             += this.datiRaggruppatiFase1Bando1[index].consegnate;
      this.totaliFase1InVerificaSmartfiberBando1   += this.datiRaggruppatiFase1Bando1[index].inVerificaSmartfiber;
      this.totaliFase1InReworkAziendaBando1        += this.datiRaggruppatiFase1Bando1[index].inReworkAzienda;
      this.totaliFase1InCaricoPresidioBando1       += this.datiRaggruppatiFase1Bando1[index].inCaricoPresidio;
      this.totaliFase1PubblicateBando1             += this.datiRaggruppatiFase1Bando1[index].pubblicate;
      this.totaliFase1ApprovateBando1              += this.datiRaggruppatiFase1Bando1[index].approvate;
      this.totaliFase1RespinteBando1               += this.datiRaggruppatiFase1Bando1[index].respinte; 
    }

    this.isLoadingFase1Bando1 = false; // Reset del flag di caricamento
    });
   
  }


  loadDatiFase1Bando2() {
    if (this.fase1Bando2Loaded || this.isLoadingFase1Bando2) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase1Bando2 = true; // Imposta subito per evitare chiamate multiple
    this.fase1Bando2Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2  ;
    if(this.isImpresa){ 
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 FASE 1 PER IMPRESA " + this.userService.getUser().azienda.id);
      queryBando2 = collectionRef
                  .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 2")
                  .orderBy("codiceStatoInfratelFase1");
    }else{
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 FASE 1 PER PRESIDIO TIM");
      queryBando2 = collectionRef
      .where("bando", "==", "BANDO 2")
      .orderBy("codiceStatoInfratelFase1");
    }
  /*  if(this.activeFasePanelIndex == 0){
    queryBando2 = collectionRef
    .where("bando", "==", "BANDO 2")
    .orderBy("codiceStatoInfratelFase1");

   }else if(this.activeFasePanelIndex == 1){

   }else if(this.activeFasePanelIndex == 2){

   } */

   onSnapshot(queryBando2, (qs) => {
      this.logger.info("[HOME DOCS] DATI BANDO 2 FASE 1 CARICATE "+ qs.docs.length + " PRATICHE");
      this.isLoading = false;
      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number;
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          sopralluogoPianificato: number;
          sopralluogoEseguito: number;
          sopralluogoKO: number;
          preventivoInAttesa: number;
          preventivoApprovato: number;
          preventivoRifiutato: number;
          preventivoKO: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
              preventivoInAttesa: number;
              preventivoApprovato: number;
              preventivoRifiutato: number;
              preventivoKO: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
      this.resetTotaliFase1Bando2();
      
     qs.forEach((doc) => {
      let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando2DaFirestore.idAziendaFase1? praticaBando2DaFirestore.idAziendaFase1 : praticaBando2DaFirestore.idAzienda;
        const impresa   = praticaBando2DaFirestore.aziendaFase1? praticaBando2DaFirestore.aziendaFase1 : praticaBando2DaFirestore.azienda;
        const regione   = praticaBando2DaFirestore.regione;

            if (!raggruppamentoPerImpresa[impresa]) {
              raggruppamentoPerImpresa[impresa] = { 
                idImpresa: idImpresa,
                totale: 0, 
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0,
                sopralluogoKO :0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
                datiPerRegione: {},
              };
            }
            if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0,
                sopralluogoKO :0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              };
            }
            raggruppamentoPerImpresa[impresa].totale += 1;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
            switch (praticaBando2DaFirestore.statoFlowdyFase1) {
              case 'IN ATTESA ODA':
                raggruppamentoPerImpresa[impresa].inAttesaODA += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA += 1;
                break;
              case 'DA ASSEGNARE':
                raggruppamentoPerImpresa[impresa].daAssegnare += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare += 1;
                break;
              case 'ASSEGNATA':
                raggruppamentoPerImpresa[impresa].assegnate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].assegnate += 1;
                break;
              case 'IN CARICO IMPRESA':
                raggruppamentoPerImpresa[impresa].inCaricoImpresa += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa += 1;
                break;
              case 'SOPRALLUOGO PIANIFICATO':
                raggruppamentoPerImpresa[impresa].sopralluogoPianificato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato += 1;
                break;
              case 'SOPRALLUOGO EFFETTUATO':
                raggruppamentoPerImpresa[impresa].sopralluogoEseguito += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito += 1;
                break;
              case 'SOPRALLUOGO KO':
                raggruppamentoPerImpresa[impresa].sopralluogoKO += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO += 1;
                break;
              case 'PREVENTIVO IN ATTESA':
                raggruppamentoPerImpresa[impresa].preventivoInAttesa += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoInAttesa += 1;
                break;
              case 'PREVENTIVO APPROVATO':
                raggruppamentoPerImpresa[impresa].preventivoApprovato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoApprovato += 1;
                break;
              case 'PREVENTIVO RIFIUTATO':
                raggruppamentoPerImpresa[impresa].preventivoRifiutato += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoRifiutato += 1;
                break;
              case 'PREVENTIVO KO':
                raggruppamentoPerImpresa[impresa].preventivoKO += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].preventivoKO += 1;
                break;    
              case 'CONSEGNATA':
                raggruppamentoPerImpresa[impresa].consegnate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate += 1;
                break;
              case 'IN VERIFICA SMARTFIBER':
                raggruppamentoPerImpresa[impresa].inVerificaSmartfiber += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber += 1;
                break;
              case 'IN REWORK AZIENDA':
                raggruppamentoPerImpresa[impresa].inReworkAzienda += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda += 1;
                break;
              case 'IN CARICO PRESIDIO':
                raggruppamentoPerImpresa[impresa].inCaricoPresidio += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio += 1;
                break;
              case 'PUBBLICATA':
                raggruppamentoPerImpresa[impresa].pubblicate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate += 1;
                break;
              case 'APPROVATA':
                raggruppamentoPerImpresa[impresa].approvate += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate += 1;
                break;
              case 'RESPINTA':
                raggruppamentoPerImpresa[impresa].respinte += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte += 1;
                break;
            }
            this.datiRaggruppatiFase1Bando2 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
              impresa,
              idImpresa:             dati.idImpresa,
              //regione:                dati.regione,
              totale:                 dati.totale,
              inAttesaODA:            dati.inAttesaODA,
              daAssegnare:            dati.daAssegnare,
              assegnate:              dati.assegnate,
              inCaricoImpresa:        dati.inCaricoImpresa,
              sopralluogoPianificato: dati.sopralluogoPianificato,
              sopralluogoEseguito:    dati.sopralluogoEseguito,
              sopralluogoKO:          dati.sopralluogoKO,
              preventivoInAttesa:     dati.preventivoInAttesa,
              preventivoApprovato:    dati.preventivoApprovato,
              preventivoRifiutato:    dati.preventivoRifiutato,
              preventivoKO:           dati.preventivoKO,
              consegnate:             dati.consegnate,
              inVerificaSmartfiber:   dati.inVerificaSmartfiber,
              inReworkAzienda:        dati.inReworkAzienda,
              inCaricoPresidio:       dati.inCaricoPresidio,
              pubblicate:             dati.pubblicate,
              approvate:              dati.approvate,
              respinte:               dati.respinte,
              datiPerRegione:         dati.datiPerRegione,
            }));
            this.datiRaggruppatiFase1Bando2Filtrati = this.datiRaggruppatiFase1Bando2.sort((a, b) => a.impresa.localeCompare(b.impresa));
  
           
      
     });


     
     for (let index = 0; index < this.datiRaggruppatiFase1Bando2.length; index++) {
        this.totaliFase1Bando2                       += this.datiRaggruppatiFase1Bando2[index].totale;
        this.totaliFase1InAttesaODABando2            += this.datiRaggruppatiFase1Bando2[index].inAttesaODA;
        this.totaliFase1DaAssegnareBando2            += this.datiRaggruppatiFase1Bando2[index].daAssegnare;
        this.totaliFase1AssegnateBando2              += this.datiRaggruppatiFase1Bando2[index].assegnate;
        this.totaliFase1InCaricoImpresaBando2        += this.datiRaggruppatiFase1Bando2[index].inCaricoImpresa;
        this.totaliFase1SopralluogoPianificatoBando2 += this.datiRaggruppatiFase1Bando2[index].sopralluogoPianificato;
        this.totaliFase1SopralluogoEseguitoBando2    += this.datiRaggruppatiFase1Bando2[index].sopralluogoEseguito;
        this.totaliFase1SopralluogoKOBando2          += this.datiRaggruppatiFase1Bando2[index].sopralluogoKO;
        this.totaliFase1PreventivoInAttesaBando2     += this.datiRaggruppatiFase1Bando2[index].preventivoInAttesa;
        this.totaliFase1PreventivoApprovatoBando2    += this.datiRaggruppatiFase1Bando2[index].preventivoApprovato;
        this.totaliFase1PreventivoRifiutatoBando2    += this.datiRaggruppatiFase1Bando2[index].preventivoRifiutato;
        this.totaliFase1PreventivoKOBando2           += this.datiRaggruppatiFase1Bando2[index].preventivoKO;
        this.totaliFase1ConsegnateBando2             += this.datiRaggruppatiFase1Bando2[index].consegnate;
        this.totaliFase1InVerificaSmartfiberBando2   += this.datiRaggruppatiFase1Bando2[index].inVerificaSmartfiber;
        this.totaliFase1InReworkAziendaBando2        += this.datiRaggruppatiFase1Bando2[index].inReworkAzienda;
        this.totaliFase1InCaricoPresidioBando2       += this.datiRaggruppatiFase1Bando2[index].inCaricoPresidio;
        this.totaliFase1PubblicateBando2             += this.datiRaggruppatiFase1Bando2[index].pubblicate;
        this.totaliFase1ApprovateBando2              += this.datiRaggruppatiFase1Bando2[index].approvate;
        this.totaliFase1RespinteBando2               += this.datiRaggruppatiFase1Bando2[index].respinte; 
    }

    this.isLoadingFase1Bando2 = false; // Reset del flag di caricamento
    });
    
   
  }

  loadDatiFase2Bando1(){
    if (this.fase2Bando1Loaded || this.isLoadingFase2Bando1) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase2Bando1 = true; // Imposta subito per evitare chiamate multiple
    this.fase2Bando1Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando1   = null;
      
      if(this.isImpresa){
        this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 E FASE 2 PER IMPRESA " + this.userService.getUser().azienda.id);
        queryBando1 = collectionRef
                    .where("idAziendaFase2", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("codiceStatoInfratelFase2");
      }else{
        this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 E FASE 2 PER PRESIDIO TIM");
        queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1")
        .orderBy("codiceStatoInfratelFase2");
      }

   onSnapshot(queryBando1, (qs) => {
      this.logger.info("[HOME DOCS] DATI BANDO 1 E FASE 2 CARICATE "+ qs.docs.length + " PRATICHE");
      this.isLoading = false;
      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number;
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          appuntamentoFissato: number;
          appuntamentoScaduto: number;
          installazioneOK: number;
          attesaTS: number;
          attivazioneKO_CPE: number;
          attivazioneKO_FO: number;
          verificaTSKO: number;
          attivazioneOK: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              installazioneOK: number;
              attesaTS: number;
              attivazioneKO_CPE: number;
              attivazioneKO_FO: number;
              verificaTSKO: number;
              attivazioneOK: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
        this.resetTotaliFase2Bando1();
      
     qs.forEach((doc) => {
      let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando1DaFirestore.idAziendaFase2? praticaBando1DaFirestore.idAziendaFase2 : praticaBando1DaFirestore.idAzienda;
        const impresa   = praticaBando1DaFirestore.aziendaFase2? praticaBando1DaFirestore.aziendaFase2 : praticaBando1DaFirestore.azienda;
        const regione   = praticaBando1DaFirestore.regione;
        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = { 
            idImpresa: idImpresa,
            totale: 0, 
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            appuntamentoFissato: 0, 
            appuntamentoScaduto: 0,
            installazioneOK: 0,
            attesaTS: 0,
            attivazioneKO_CPE: 0,
            attivazioneKO_FO: 0,
            verificaTSKO: 0,
            attivazioneOK: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
            datiPerRegione: {},
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            appuntamentoFissato: 0, 
            appuntamentoScaduto: 0,
            installazioneOK: 0,
            attesaTS: 0,
            attivazioneKO_CPE: 0,
            attivazioneKO_FO: 0,
            verificaTSKO: 0,
            attivazioneOK: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
          };
        }
        if((praticaBando1DaFirestore.codiceStatoInfratelFase1 ==='1-6'  || praticaBando1DaFirestore.showFase2) && praticaBando1DaFirestore.statoFlowdyFase2 !== 'SOPRALLUOGO KO'){
          //
          raggruppamentoPerImpresa[impresa].totale                          += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale  += 1;
          switch(praticaBando1DaFirestore.statoFlowdyFase2){
            case 'IN ATTESA ODA':
              raggruppamentoPerImpresa[impresa].inAttesaODA++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA++;
              break;
            case 'DA ASSEGNARE':
              raggruppamentoPerImpresa[impresa].daAssegnare++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare++;
              break;
            case 'ASSEGNATA':
              raggruppamentoPerImpresa[impresa].assegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].assegnate++;
              break;
            case 'IN CARICO IMPRESA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'APPUNTAMENTO FISSATO':
              if(this.checkAppuntamentoPassato(praticaBando1DaFirestore)){
                raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoScaduto++;
              }else{
                raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoFissato++;
              }
              break;
            case 'INSTALLAZIONE EFFETTUATA':
              raggruppamentoPerImpresa[impresa].installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].installazioneOK++;
              break;
            case 'IN ATTESA CONFERMA TIM SUPPORT':
              raggruppamentoPerImpresa[impresa].attesaTS++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attesaTS++;
              break;
            case 'ATTIVAZIONE KO CPE':
              raggruppamentoPerImpresa[impresa].attivazioneKO_CPE++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO_CPE++;
              break;
            case 'ATTIVAZIONE KO FO':
              raggruppamentoPerImpresa[impresa].attivazioneKO_FO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO_FO++;
              break;
            case 'CONTROLLO TIM SUPPORT KO':
              raggruppamentoPerImpresa[impresa].verificaTSKO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].verificaTSKO++;
              break;
            case 'CONTROLLO TIM SUPPORT OK':
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
              break;
            case 'ATTIVAZIONE OK':
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
              break;
            case 'CONSEGNATA':
              raggruppamentoPerImpresa[impresa].consegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate++;
              break;
            case 'IN VERIFICA SMARTFIBER':
              raggruppamentoPerImpresa[impresa].inVerificaSmartfiber++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber++;
              break;
            case 'IN REWORK AZIENDA':
              raggruppamentoPerImpresa[impresa].inReworkAzienda++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda++;
              break;
            case 'IN CARICO PRESIDIO':
              raggruppamentoPerImpresa[impresa].inCaricoPresidio++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio++;
              break;
            case 'PUBBLICATA':
              raggruppamentoPerImpresa[impresa].pubblicate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              break;
            case 'APPROVATA':
              raggruppamentoPerImpresa[impresa].approvate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate++;
              break;
            case 'RESPINTA': 
              raggruppamentoPerImpresa[impresa].respinte++; 
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              break;
            default:
              this.logger.info("[HOME DOCS] PRATICA " + praticaBando1DaFirestore.cui + " CON STATO NON GESTITO > " + praticaBando1DaFirestore.statoFlowdyFase2);

              break;
          }

      }else{
        
        }

     });
      this.datiRaggruppatiFase2Bando1 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
        impresa,
        idImpresa:             dati.idImpresa,
        //regione:                dati.regione,
        totale:                 dati.totale,
        inAttesaODA:            dati.inAttesaODA,
        daAssegnare:            dati.daAssegnare,
        assegnate:              dati.assegnate,
        inCaricoImpresa:        dati.inCaricoImpresa,
        appuntamentoFissato:    dati.appuntamentoFissato,
        appuntamentoScaduto:   dati.appuntamentoScaduto,
        installazioneOK:        dati.installazioneOK,
        attesaTS:              dati.attesaTS,
        attivazioneKO_CPE:     dati.attivazioneKO_CPE,
        attivazioneKO_FO:      dati.attivazioneKO_FO,
        verificaTSKO:           dati.verificaTSKO,
        attivazioneOK:          dati.attivazioneOK,
        consegnate:             dati.consegnate,
        inVerificaSmartfiber:   dati.inVerificaSmartfiber,
        inReworkAzienda:        dati.inReworkAzienda,
        inCaricoPresidio:       dati.inCaricoPresidio,
        pubblicate:             dati.pubblicate,
        approvate:              dati.approvate,
        respinte:               dati.respinte,
        datiPerRegione:         dati.datiPerRegione,
      }));
      this.datiRaggruppatiFase2Bando1Filtrati = this.datiRaggruppatiFase2Bando1.sort((a, b) => a.impresa.localeCompare(b.impresa));
      //this.logger.info("[HOME DOCS] FASE 2 BANDO 1 > " +  this.datiRaggruppatiFase2Bando1.length);
      this.caricaTotaliFase2Bando1();
        /* for (let index = 0; index < this.datiRaggruppatiFase2Bando1.length; index++) {
          this.totaliFase2Bando1              += this.datiRaggruppatiFase2Bando1[index].totale;
          this.totaliFase2InAttesaODABando1 += this.datiRaggruppatiFase2Bando1[index].inAttesaODA;
          this.totaliFase2DaAssegnareBando1 += this.datiRaggruppatiFase2Bando1[index].daAssegnare;
          this.totaliFase2AssegnateBando1 += this.datiRaggruppatiFase2Bando1[index].assegnate;
          this.totaliFase2InCaricoImpresaBando1 += this.datiRaggruppatiFase2Bando1[index].inCaricoImpresa;
          this.totaliFase2AppuntamentoFissatoBando1 += this.datiRaggruppatiFase2Bando1[index].appuntamentoFissato;
          this.totaliFase2AppuntamentoScadutoBando1 += this.datiRaggruppatiFase2Bando1[index].appuntamentoScaduto;
          this.totaliFase2InstallazioneOKBando1 += this.datiRaggruppatiFase2Bando1[index].installazioneOK;
          this.totaliFase2AttesaTSBando1 += this.datiRaggruppatiFase2Bando1[index].attesaTS;
          this.totaliFase2AttivazioneKO_CPEBando1 += this.datiRaggruppatiFase2Bando1[index].attivazioneKO_CPE;
          this.totaliFase2AttivazioneKO_FOBando1 += this.datiRaggruppatiFase2Bando1[index].attivazioneKO_FO;
          this.totaliFase2VerificaTSKO_Bando1 += this.datiRaggruppatiFase2Bando1[index].verificaTSKO;
          this.totaliFase2AttivazioneOKBando1 += this.datiRaggruppatiFase2Bando1[index].attivazioneOK;
          this.totaliFase2ConsegnateBando1 += this.datiRaggruppatiFase2Bando1[index].consegnate;
          this.totaliFase2InVerificaSmartfiberBando1 += this.datiRaggruppatiFase2Bando1[index].inVerificaSmartfiber;
          this.totaliFase2InReworkAziendaBando1 += this.datiRaggruppatiFase2Bando1[index].inReworkAzienda;
          this.totaliFase2InCaricoPresidioBando1 += this.datiRaggruppatiFase2Bando1[index].inCaricoPresidio;
          this.totaliFase2PubblicateBando1 += this.datiRaggruppatiFase2Bando1[index].pubblicate;
          this.totaliFase2ApprovateBando1 += this.datiRaggruppatiFase2Bando1[index].approvate;
          this.totaliFase2RespinteBando1 += this.datiRaggruppatiFase2Bando1[index].respinte;
          
        } */

        // this.logger.info("[HOME DOCS] TOTALI FASE 2 BANDO 1 > " + this.totaliFase2Bando1);
           
      this.isLoadingFase2Bando1 = false; // Reset del flag di caricamento
     });

  }

  loadDatiFase2Bando2(){
    if (this.fase2Bando2Loaded || this.isLoadingFase2Bando2) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase2Bando2 = true; // Imposta subito per evitare chiamate multiple
    this.fase2Bando2Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2   = null;
    
    if(this.isImpresa){
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 E FASE 2 PER IMPRESA " + this.userService.getUser().azienda.id);
      queryBando2 = collectionRef
                  .where("idAziendaFase2", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 2")
                  .orderBy("codiceStatoInfratelFase2");
    }else{
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 E FASE 2 PER PRESIDIO TIM");
      queryBando2 = collectionRef
      .where("bando", "==", "BANDO 2")
      .orderBy("codiceStatoInfratelFase2");
    }
    
   /*  let queryBando1   = collectionRef
    .where("bando", "==", "BANDO 2")
    .orderBy("codiceStatoInfratelFase2"); */
    this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 E FASE 2");

   onSnapshot(queryBando2, (qs) => {
      this.logger.info("[HOME DOCS] DATI BANDO 2 E FASE 2 CARICATE "+ qs.docs.length + " PRATICHE");
      this.isLoading = false;
      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number;
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          appuntamentoFissato: number;
          appuntamentoScaduto: number;
          installazioneOK: number;
          attesaTS: number;
          attivazioneKO_CPE: number;
          attivazioneKO_FO: number;
          verificaTSKO: number;
          attivazioneOK: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              installazioneOK: number;
              attesaTS: number;
              attivazioneKO_CPE: number;
              attivazioneKO_FO: number;
              verificaTSKO: number;
              attivazioneOK: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
        this.resetTotaliFase2Bando2();
      
     qs.forEach((doc) => {
      let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando2DaFirestore.idAziendaFase2? praticaBando2DaFirestore.idAziendaFase2 : praticaBando2DaFirestore.idAzienda;
        const impresa   = praticaBando2DaFirestore.aziendaFase2? praticaBando2DaFirestore.aziendaFase2 : praticaBando2DaFirestore.azienda;
        const regione   = praticaBando2DaFirestore.regione;
        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = { 
            idImpresa: idImpresa,
            totale: 0, 
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            appuntamentoFissato: 0, 
            appuntamentoScaduto: 0,
            installazioneOK: 0,
            attesaTS: 0,
            attivazioneKO_CPE: 0,
            attivazioneKO_FO: 0,
            verificaTSKO: 0,
            attivazioneOK: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
            datiPerRegione: {},
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            appuntamentoFissato: 0, 
            appuntamentoScaduto: 0,
            installazioneOK: 0,
            attesaTS: 0,
            attivazioneKO_CPE: 0,
            attivazioneKO_FO: 0,
            verificaTSKO: 0,
            attivazioneOK: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
          };
        }
        if(praticaBando2DaFirestore.statoFlowdyFase2 && (praticaBando2DaFirestore.codiceStatoInfratelFase1 ==='1-6'  || praticaBando2DaFirestore.showFase2) && praticaBando2DaFirestore.statoFlowdyFase2 !== 'SOPRALLUOGO KO'){
          //
          raggruppamentoPerImpresa[impresa].totale                          += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale  += 1;
          switch(praticaBando2DaFirestore.statoFlowdyFase2){
            case 'IN ATTESA ODA':
              raggruppamentoPerImpresa[impresa].inAttesaODA++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA++;
              break;
            case 'DA ASSEGNARE':
              //this.logger.info(praticaBando2DaFirestore.cui);

              raggruppamentoPerImpresa[impresa].daAssegnare++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare++;
              break;
            case 'ASSEGNATA':
              raggruppamentoPerImpresa[impresa].assegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].assegnate++;
              break;
            case 'IN CARICO IMPRESA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'APPUNTAMENTO FISSATO':
              if(this.checkAppuntamentoPassato(praticaBando2DaFirestore)){
                raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoScaduto++;
              }else{
                raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoFissato++;
              }
              break;
            case 'INSTALLAZIONE EFFETTUATA':
              raggruppamentoPerImpresa[impresa].installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].installazioneOK++;
              break;
            case 'IN ATTESA CONFERMA TIM SUPPORT':
              raggruppamentoPerImpresa[impresa].attesaTS++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attesaTS++;
              break;
            case 'ATTIVAZIONE KO CPE':
              raggruppamentoPerImpresa[impresa].attivazioneKO_CPE++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO_CPE++;
              break;
            case 'ATTIVAZIONE KO FO':
              raggruppamentoPerImpresa[impresa].attivazioneKO_FO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO_FO++;
              break;
            case 'CONTROLLO TIM SUPPORT KO':
              raggruppamentoPerImpresa[impresa].verificaTSKO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].verificaTSKO++;
              break;
            case 'CONTROLLO TIM SUPPORT OK':
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
              break;
            case 'ATTIVAZIONE OK':
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
              break;
            case 'CONSEGNATA':
              raggruppamentoPerImpresa[impresa].consegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate++;
              break;
            case 'IN VERIFICA SMARTFIBER':
              raggruppamentoPerImpresa[impresa].inVerificaSmartfiber++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber++;
              break;
            case 'IN REWORK AZIENDA':
              raggruppamentoPerImpresa[impresa].inReworkAzienda++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda++;
              break;
            case 'IN CARICO PRESIDIO':
              raggruppamentoPerImpresa[impresa].inCaricoPresidio++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio++;
              break;
            case 'PUBBLICATA':
              raggruppamentoPerImpresa[impresa].pubblicate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              break;
            case 'APPROVATA':
              raggruppamentoPerImpresa[impresa].approvate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate++;
              break;
            case 'RESPINTA': 
              raggruppamentoPerImpresa[impresa].respinte++; 
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              break;
            default:
              this.logger.info("[HOME DOCS] PRATICA " + praticaBando2DaFirestore.cui + " CON STATO NON GESTITO > " + praticaBando2DaFirestore.statoFlowdyFase2);

              break;
          }

      }else{
        /* if(!praticaBando2DaFirestore.statoFlowdyFase2 && praticaBando2DaFirestore.statoFlowdyFase1 ==='ASSEGNATA'  ){
          this.logger.info("[HOME DOCS] PRATICA " + praticaBando2DaFirestore.cui + " CON STATO FLOWDY FASSE 2 NON DEFINITO > " + praticaBando2DaFirestore.statoFlowdyFase1 + " " + praticaBando2DaFirestore.codiceStatoInfratelFase1 + " " + praticaBando2DaFirestore.showFase2);

        } */
        }

     });
      this.datiRaggruppatiFase2Bando2 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
        impresa,
        idImpresa:             dati.idImpresa,
        //regione:                dati.regione,
        totale:                 dati.totale,
        inAttesaODA:            dati.inAttesaODA,
        daAssegnare:            dati.daAssegnare,
        assegnate:              dati.assegnate,
        inCaricoImpresa:        dati.inCaricoImpresa,
        appuntamentoFissato:    dati.appuntamentoFissato,
        appuntamentoScaduto:   dati.appuntamentoScaduto,
        installazioneOK:        dati.installazioneOK,
        attesaTS:              dati.attesaTS,
        attivazioneKO_CPE:     dati.attivazioneKO_CPE,
        attivazioneKO_FO:      dati.attivazioneKO_FO,
        verificaTSKO:           dati.verificaTSKO,
        attivazioneOK:          dati.attivazioneOK,
        consegnate:             dati.consegnate,
        inVerificaSmartfiber:   dati.inVerificaSmartfiber,
        inReworkAzienda:        dati.inReworkAzienda,
        inCaricoPresidio:       dati.inCaricoPresidio,
        pubblicate:             dati.pubblicate,
        approvate:              dati.approvate,
        respinte:               dati.respinte,
        datiPerRegione:         dati.datiPerRegione,
      }));
      this.datiRaggruppatiFase2Bando2Filtrati = this.datiRaggruppatiFase2Bando2.sort((a, b) => a.impresa.localeCompare(b.impresa));
      this.caricaTotaliFase2Bando2();
       /*  for (let index = 0; index < this.datiRaggruppatiFase2Bando2.length; index++) {
          this.totaliFase2Bando2                      += this.datiRaggruppatiFase2Bando2[index].totale;
          this.totaliFase2InAttesaODABando2           += this.datiRaggruppatiFase2Bando2[index].inAttesaODA;
          this.totaliFase2DaAssegnareBando2           += this.datiRaggruppatiFase2Bando2[index].daAssegnare;
          this.totaliFase2AssegnateBando2             += this.datiRaggruppatiFase2Bando2[index].assegnate;
          this.totaliFase2InCaricoImpresaBando2       += this.datiRaggruppatiFase2Bando2[index].inCaricoImpresa;
          this.totaliFase2AppuntamentoFissatoBando2   += this.datiRaggruppatiFase2Bando2[index].appuntamentoFissato;
          this.totaliFase2AppuntamentoScadutoBando2   += this.datiRaggruppatiFase2Bando2[index].appuntamentoScaduto;
          this.totaliFase2InstallazioneOKBando2       += this.datiRaggruppatiFase2Bando2[index].installazioneOK;
          this.totaliFase2AttesaTSBando2              += this.datiRaggruppatiFase2Bando2[index].attesaTS;
          this.totaliFase2AttivazioneKO_CPEBando2     += this.datiRaggruppatiFase2Bando2[index].attivazioneKO_CPE;
          this.totaliFase2AttivazioneKO_FOBando2      += this.datiRaggruppatiFase2Bando2[index].attivazioneKO_FO;
          this.totaliFase2VerificaTSKO_Bando2         += this.datiRaggruppatiFase2Bando2[index].verificaTSKO;
          this.totaliFase2AttivazioneOKBando2         += this.datiRaggruppatiFase2Bando2[index].attivazioneOK;
          this.totaliFase2ConsegnateBando2            += this.datiRaggruppatiFase2Bando2[index].consegnate;
          this.totaliFase2InVerificaSmartfiberBando2  += this.datiRaggruppatiFase2Bando2[index].inVerificaSmartfiber;
          this.totaliFase2InReworkAziendaBando2       += this.datiRaggruppatiFase2Bando2[index].inReworkAzienda;
          this.totaliFase2InCaricoPresidioBando2      += this.datiRaggruppatiFase2Bando2[index].inCaricoPresidio;
          this.totaliFase2PubblicateBando2            += this.datiRaggruppatiFase2Bando2[index].pubblicate;
          this.totaliFase2ApprovateBando2             += this.datiRaggruppatiFase2Bando2[index].approvate;
          this.totaliFase2RespinteBando2              += this.datiRaggruppatiFase2Bando2[index].respinte;
          
        } */

      //  this.logger.info("[HOME DOCS] TOTALI FASE 2 BANDO 2 > " + this.totaliFase2Bando1);
           
      this.isLoadingFase2Bando2 = false; // Reset del flag di caricamento
     });

  }

  loadDatiFase3Bando1(){
    if (this.fase3Bando1Loaded || this.isLoadingFase3Bando1) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase3Bando1 = true; // Imposta subito per evitare chiamate multiple
    this.fase3Bando1Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1   = null;
    if(this.isImpresa){
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 FASE 3 PER IMPRESA " + this.userService.getUser().azienda.id);
      queryBando1 = collectionRef
                  .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 1")
                  .where("codiceStatoInfratelFase2", "==", "2-6")
      .orderBy("codiceStatoInfratelFase3");
    }else{
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 1 FASE 3 PER PRESIDIO TIM");
      queryBando1 = collectionRef
      .where("bando", "==", "BANDO 1")
      .where("codiceStatoInfratelFase2", "==", "2-6")
      .orderBy("codiceStatoInfratelFase3");
    }


   onSnapshot(queryBando1, (qs) => {
    this.logger.info("[HOME DOCS] DATI BANDO 1 FASE 3 ARRIVATI "+qs.size + " PRATICHE");

      this.isLoading = false;
      this.resetTotaliFase3Bando1();
      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number,
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          inProgettazione: number;
          inFirma: number;
          firmate: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              inProgettazione: number;
              inFirma: number;
              firmate: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
        let contatorePraticheSenzaODA = 0
      
     qs.forEach((doc) => {
      let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando1DaFirestore.idAziendaFase3? praticaBando1DaFirestore.idAziendaFase3 : praticaBando1DaFirestore.idAzienda;
        const impresa   = praticaBando1DaFirestore.aziendaFase3? praticaBando1DaFirestore.aziendaFase3 : praticaBando1DaFirestore.azienda;
        const regione   = praticaBando1DaFirestore.regione;
        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = { 
            idImpresa: idImpresa,
            totale: 0, 
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            inProgettazione: 0,
            inFirma: 0,
            firmate: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
            datiPerRegione: {},
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            inProgettazione: 0,
            inFirma: 0,
            firmate: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
          };
        }        
      //  if(praticaBando1DaFirestore.codiceStatoInfratelFase2 ==='2-6' ){
          //
          raggruppamentoPerImpresa[impresa].totale                          += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale  += 1;
          switch(praticaBando1DaFirestore.statoFlowdyFase3){
            case 'IN ATTESA ODA':
              raggruppamentoPerImpresa[impresa].inAttesaODA++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA++;
              break;
            case 'DA ASSEGNARE':
              raggruppamentoPerImpresa[impresa].daAssegnare++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare++;
              break;
            case 'ASSEGNATA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'IN CARICO IMPRESA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'IN PROGETTAZIONE':
              raggruppamentoPerImpresa[impresa].inProgettazione++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inProgettazione++;
              break;
            case 'IN FIRMA':
              raggruppamentoPerImpresa[impresa].inFirma++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inFirma++;
              break;
            case 'FIRMATA':
              raggruppamentoPerImpresa[impresa].firmate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].firmate++;
              break;
            case 'CONSEGNATA':
              raggruppamentoPerImpresa[impresa].consegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate++;
              break;
            case 'IN VERIFICA SMARTFIBER':
              raggruppamentoPerImpresa[impresa].inVerificaSmartfiber++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber++;
              break;
            case 'IN REWORK AZIENDA':
              raggruppamentoPerImpresa[impresa].inReworkAzienda++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda++;
              break;
            case 'IN CARICO PRESIDIO':
              raggruppamentoPerImpresa[impresa].inCaricoPresidio++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio++;
              break;
            case 'PUBBLICATA':
              raggruppamentoPerImpresa[impresa].pubblicate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              break;
            case 'APPROVATA':
              raggruppamentoPerImpresa[impresa].approvate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate++;
              break;
            case 'RESPINTA': 
              raggruppamentoPerImpresa[impresa].respinte++; 
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              break;
            default:
              if(praticaBando1DaFirestore.codiceStatoInfratelFase3 ==='3-3'){
                raggruppamentoPerImpresa[impresa].firmate++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].firmate++;
                
              }else if(praticaBando1DaFirestore.codiceStatoInfratelFase3 ==='3-4'){
                raggruppamentoPerImpresa[impresa].pubblicate++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              }else if(praticaBando1DaFirestore.codiceStatoInfratelFase3 ==='3-5'){
                raggruppamentoPerImpresa[impresa].respinte++; 
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              }else {
                this.logger.info("[HOME DOCS] PRATICA BANDO 1 " + praticaBando1DaFirestore.cui + " CON STATO NON GESTITO > " + praticaBando1DaFirestore.statoFlowdyFase3 + " - " + praticaBando1DaFirestore.codiceStatoInfratelFase3);

              }
              break;
          }

    //  }

     });
      this.datiRaggruppatiFase3Bando1 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
        impresa,
        idImpresa:             dati.idImpresa,
        //regione:                dati.regione,
        totale:                 dati.totale,
        inAttesaODA:            dati.inAttesaODA,
        daAssegnare:            dati.daAssegnare,
        assegnate:              dati.assegnate,
        inCaricoImpresa:        dati.inCaricoImpresa,
        inProgettazione:        dati.inProgettazione,
        inFirma:                dati.inFirma,
        firmate:                dati.firmate,
        consegnate:             dati.consegnate,
        inVerificaSmartfiber:   dati.inVerificaSmartfiber,
        inReworkAzienda:        dati.inReworkAzienda,
        inCaricoPresidio:       dati.inCaricoPresidio,
        pubblicate:             dati.pubblicate,
        approvate:              dati.approvate,
        respinte:               dati.respinte,
        datiPerRegione:         dati.datiPerRegione,
      }));
      this.datiRaggruppatiFase3Bando1Filtrati = this.datiRaggruppatiFase3Bando1.sort((a, b) => a.impresa.localeCompare(b.impresa));
      this.caricaTotaliFase3Bando1();

        //this.logger.info("[HOME DOCS] TOTALI FASE 3 BANDO 1 > " + this.totaliFase3Bando1);
        //this.logger.info("[HOME DOCS] PRATICHE SENZA ODA > " + contatorePraticheSenzaODA);
      
      this.isLoadingFase3Bando1 = false; // Reset del flag di caricamento
     });

  }

  loadDatiFase3Bando2(){
    if (this.fase3Bando2Loaded || this.isLoadingFase3Bando2) {
      return; // Evita caricamenti multipli
    }
    this.isLoading = true;
    this.isLoadingFase3Bando2 = true; // Imposta subito per evitare chiamate multiple
    this.fase3Bando2Loaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2   = null;
    if(this.isImpresa){
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 E FASE 3 PER IMPRESA " + this.userService.getUser().azienda.id);

      queryBando2 = collectionRef
                  .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2")
                  .where("codiceStatoInfratelFase2", "==", "2-6")
      .orderBy("codiceStatoInfratelFase3");
    }else{
      this.logger.info("[HOME DOCS] LOADING DATI BANDO 2 E FASE 3 PER PRESIDIO TIM");
      queryBando2 = collectionRef
      .where("bando", "==", "BANDO 2")
      .where("codiceStatoInfratelFase2", "==", "2-6")
      .orderBy("codiceStatoInfratelFase3");
    }
    
    
    /* let queryBando1   = collectionRef
      .where("bando", "==", "BANDO 2")
      .where("codiceStatoInfratelFase2", "==", "2-6")
      .orderBy("codiceStatoInfratelFase3"); */

   onSnapshot(queryBando2, (qs) => {
      this.isLoading = false;
      this.resetTotaliFase3Bando2();
      this.logger.info("[HOME DOCS] DATI BANDO 2 FASE 3 > " + qs.size);

      const raggruppamentoPerImpresa: { 
        [key: string]: { 
          idImpresa: number,
          totale: number,
          inAttesaODA: number,
          daAssegnare: number;
          assegnate: number;
          inCaricoImpresa: number;
          inProgettazione: number;
          inFirma: number;
          firmate: number;
          consegnate: number;
          inVerificaSmartfiber: number;
          inReworkAzienda: number;
          inCaricoPresidio: number;
          pubblicate: number;
          approvate: number;
          respinte: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              inAttesaODA: number;
              daAssegnare: number;
              assegnate: number;
              inCaricoImpresa: number;
              inProgettazione: number;
              inFirma: number;
              firmate: number;
              consegnate: number;
              inVerificaSmartfiber: number;
              inReworkAzienda: number;
              inCaricoPresidio: number;
              pubblicate: number;
              approvate: number;
              respinte: number;
            };
          };
        } 
      } = {};
        let contatorePraticheSenzaODA = 0
      
     qs.forEach((doc) => {
      let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        const idImpresa = praticaBando2DaFirestore.idAziendaFase3? praticaBando2DaFirestore.idAziendaFase3 : praticaBando2DaFirestore.idAzienda;
        const impresa   = praticaBando2DaFirestore.aziendaFase3? praticaBando2DaFirestore.aziendaFase3 : praticaBando2DaFirestore.azienda;
        const regione   = praticaBando2DaFirestore.regione;
        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = { 
            idImpresa: idImpresa,
            totale: 0, 
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            inProgettazione: 0,
            inFirma: 0,
            firmate: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
            datiPerRegione: {},
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            inAttesaODA: 0,
            daAssegnare: 0,
            assegnate: 0,
            inCaricoImpresa: 0,
            inProgettazione: 0,
            inFirma: 0,
            firmate: 0,
            consegnate: 0,
            inVerificaSmartfiber: 0,
            inReworkAzienda: 0,
            inCaricoPresidio: 0,
            pubblicate: 0,
            approvate: 0,
            respinte: 0,
          };
        }        //&& praticaBando2DaFirestore.sopralluogoOk
        if(praticaBando2DaFirestore.codiceStatoInfratelFase2 ==='2-6' ){
          //
          raggruppamentoPerImpresa[impresa].totale                          += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale  += 1;
          switch(praticaBando2DaFirestore.statoFlowdyFase3){
            case 'IN ATTESA ODA':
              raggruppamentoPerImpresa[impresa].inAttesaODA++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inAttesaODA++;
              break;
            case 'DA ASSEGNARE':
              raggruppamentoPerImpresa[impresa].daAssegnare++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].daAssegnare++;
              break;
            case 'ASSEGNATA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'IN CARICO IMPRESA':
              raggruppamentoPerImpresa[impresa].inCaricoImpresa++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoImpresa++;
              break;
            case 'IN PROGETTAZIONE':
              raggruppamentoPerImpresa[impresa].inProgettazione++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inProgettazione++;
              break;
            case 'IN FIRMA':
              raggruppamentoPerImpresa[impresa].inFirma++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inFirma++;
              break;
            case 'FIRMATA':
              raggruppamentoPerImpresa[impresa].firmate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].firmate++;
              break;
            case 'CONSEGNATA':
              raggruppamentoPerImpresa[impresa].consegnate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].consegnate++;
              break;
            case 'IN VERIFICA SMARTFIBER':
              raggruppamentoPerImpresa[impresa].inVerificaSmartfiber++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inVerificaSmartfiber++;
              break;
            case 'IN REWORK AZIENDA':
              raggruppamentoPerImpresa[impresa].inReworkAzienda++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inReworkAzienda++;
              break;
            case 'IN CARICO PRESIDIO':
              raggruppamentoPerImpresa[impresa].inCaricoPresidio++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].inCaricoPresidio++;
              break;
            case 'PUBBLICATA':
              raggruppamentoPerImpresa[impresa].pubblicate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              break;
            case 'APPROVATA':
              raggruppamentoPerImpresa[impresa].approvate++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].approvate++;
              break;
            case 'RESPINTA': 
              raggruppamentoPerImpresa[impresa].respinte++; 
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              break;
            default:
              if(praticaBando2DaFirestore.codiceStatoInfratelFase3 ==='3-3'){
                raggruppamentoPerImpresa[impresa].firmate++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].firmate++;
                
              }else if(praticaBando2DaFirestore.codiceStatoInfratelFase3 ==='3-4'){
                raggruppamentoPerImpresa[impresa].pubblicate++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].pubblicate++;
              }else if(praticaBando2DaFirestore.codiceStatoInfratelFase3 ==='3-5'){
                raggruppamentoPerImpresa[impresa].respinte++; 
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].respinte++;
              }else {
                this.logger.info("[HOME DOCS] PRATICA BANDO 2 " + praticaBando2DaFirestore.cui + " CON STATO NON GESTITO > " + praticaBando2DaFirestore.statoFlowdyFase3 + " - " + praticaBando2DaFirestore.codiceStatoInfratelFase3);

              }
              break;
          }

      }

     });
      this.datiRaggruppatiFase3Bando2 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
        impresa,
        idImpresa:             dati.idImpresa,
        //regione:                dati.regione,
        totale:                 dati.totale,
        inAttesaODA:            dati.inAttesaODA,
        daAssegnare:            dati.daAssegnare,
        assegnate:              dati.assegnate,
        inCaricoImpresa:        dati.inCaricoImpresa,
        inProgettazione:        dati.inProgettazione,
        inFirma:                dati.inFirma,
        firmate:                dati.firmate,
        consegnate:             dati.consegnate,
        inVerificaSmartfiber:   dati.inVerificaSmartfiber,
        inReworkAzienda:        dati.inReworkAzienda,
        inCaricoPresidio:       dati.inCaricoPresidio,
        pubblicate:             dati.pubblicate,
        approvate:              dati.approvate,
        respinte:               dati.respinte,
        datiPerRegione:         dati.datiPerRegione,
      }));
      this.datiRaggruppatiFase3Bando2Filtrati = this.datiRaggruppatiFase3Bando2.sort((a, b) => a.impresa.localeCompare(b.impresa));
      this.caricaTotaliFase3Bando2();

       // this.logger.info("[HOME DOCS] TOTALI FASE 3 BANDO 2 > " + this.totaliFase3Bando2);
       // this.logger.info("[HOME DOCS] PRATICHE SENZA ODA > " + contatorePraticheSenzaODA);
      
      this.isLoadingFase3Bando2 = false; // Reset del flag di caricamento
     });

  }

  checkAppuntamentoPassato(pratica:PraticaFlowdy2_Firestore):boolean{
    if(pratica.dataAppuntamentoFase2){
      const oggi = new Date(); 
      const dataAppuntamentoDaControllare = new Date(pratica.dataAppuntamentoFase2.toDate().getFullYear(),  pratica.dataAppuntamentoFase2.toDate().getMonth(), pratica.dataAppuntamentoFase2.toDate().getDate() + 2); 
      if(pratica.dataAppuntamentoFase2 && !pratica.installazioneRouterOk ){
        if(dataAppuntamentoDaControllare < oggi){
          return true
        }
        return false;
      }
    }
    return false;
   }

  resetTotaliFase1Bando1(){
    this.totaliFase1Bando1                         = 0;
    this.totaliFase1InAttesaODABando1              = 0;
    this.totaliFase1DaAssegnareBando1              = 0;
    this.totaliFase1AssegnateBando1                = 0;
    this.totaliFase1InCaricoImpresaBando1          = 0;
    this.totaliFase1SopralluogoPianificatoBando1   = 0;
    this.totaliFase1SopralluogoEseguitoBando1      = 0;
    this.totaliFase1SopralluogoKOBando1            = 0;
    this.totaliFase1PreventivoInAttesaBando1      = 0;
    this.totaliFase1PreventivoApprovatoBando1     = 0;
    this.totaliFase1PreventivoRifiutatoBando1     = 0;
    this.totaliFase1PreventivoKOBando1            = 0;
    this.totaliFase1ConsegnateBando1              = 0;
    this.totaliFase1InVerificaSmartfiberBando1    = 0;
    this.totaliFase1InReworkAziendaBando1         = 0;
    this.totaliFase1InCaricoPresidioBando1        = 0;
    this.totaliFase1PubblicateBando1              = 0;
    this.totaliFase1ApprovateBando1               = 0;
    this.totaliFase1RespinteBando1                 = 0;
  }

  resetTotaliFase1Bando2(){
    this.totaliFase1Bando2                         = 0;
    this.totaliFase1InAttesaODABando2              = 0;
    this.totaliFase1DaAssegnareBando2              = 0;
    this.totaliFase1AssegnateBando2                = 0;
    this.totaliFase1InCaricoImpresaBando2          = 0;
    this.totaliFase1SopralluogoPianificatoBando2   = 0;
    this.totaliFase1SopralluogoEseguitoBando2     = 0;
    this.totaliFase1SopralluogoKOBando2           = 0;
    this.totaliFase1PreventivoInAttesaBando2      = 0;
    this.totaliFase1PreventivoApprovatoBando2     = 0;
    this.totaliFase1PreventivoRifiutatoBando2     = 0;
    this.totaliFase1PreventivoKOBando2            = 0;
    this.totaliFase1ConsegnateBando2              = 0;
    this.totaliFase1InVerificaSmartfiberBando2    = 0;
    this.totaliFase1InReworkAziendaBando2         = 0;
    this.totaliFase1InCaricoPresidioBando2        = 0;
    this.totaliFase1PubblicateBando2              = 0;
    this.totaliFase1ApprovateBando2               = 0;
    this.totaliFase1RespinteBando2                = 0;
  }


  resetTotaliFase2Bando1(){
    this.totaliFase2Bando1                         = 0;
    this.totaliFase2InAttesaODABando1              = 0;
    this.totaliFase2DaAssegnareBando1              = 0;
    this.totaliFase2AssegnateBando1                = 0;
    this.totaliFase2InCaricoImpresaBando1          = 0;
    this.totaliFase2AppuntamentoFissatoBando1      = 0;
    this.totaliFase2AppuntamentoScadutoBando1     = 0;
    this.totaliFase2InstallazioneOKBando1         = 0;
    this.totaliFase2AttesaTSBando1                = 0;
    this.totaliFase2AttivazioneKO_CPEBando1       = 0;
    this.totaliFase2AttivazioneKO_FOBando1        = 0;
    this.totaliFase2VerificaTSKO_Bando1           = 0;
    this.totaliFase2AttivazioneOKBando1            = 0;
    this.totaliFase2ConsegnateBando1              = 0;
    this.totaliFase2InVerificaSmartfiberBando1    = 0;
    this.totaliFase2InReworkAziendaBando1         = 0;
    this.totaliFase2InCaricoPresidioBando1        = 0;
    this.totaliFase2PubblicateBando1              = 0;
    this.totaliFase2ApprovateBando1               = 0;
    this.totaliFase2RespinteBando1                = 0;
  }

  resetTotaliFase2Bando2(){
    this.totaliFase2Bando2                         = 0;
    this.totaliFase2InAttesaODABando2              = 0;
    this.totaliFase2DaAssegnareBando2              = 0;
    this.totaliFase2AssegnateBando2                = 0;
    this.totaliFase2InCaricoImpresaBando2          = 0;
    this.totaliFase2AppuntamentoFissatoBando2      = 0;
    this.totaliFase2AppuntamentoScadutoBando2     = 0;
    this.totaliFase2InstallazioneOKBando2         = 0;
    this.totaliFase2AttesaTSBando2                = 0;
    this.totaliFase2AttivazioneKO_CPEBando2       = 0;
    this.totaliFase2AttivazioneKO_FOBando2        = 0;
    this.totaliFase2VerificaTSKO_Bando2           = 0;
    this.totaliFase2AttivazioneOKBando2            = 0;
    this.totaliFase2ConsegnateBando2              = 0;
    this.totaliFase2InVerificaSmartfiberBando2    = 0;
    this.totaliFase2InReworkAziendaBando2         = 0;
    this.totaliFase2InCaricoPresidioBando2        = 0;
    this.totaliFase2PubblicateBando2              = 0;
    this.totaliFase2ApprovateBando2               = 0;
    this.totaliFase2RespinteBando2                = 0;
  }


  resetTotaliFase3Bando1(){
    this.totaliFase3Bando1 = 0;
    this.totaliFase3InAttesaODABando1 = 0;
    this.totaliFase3DaAssegnareBando1 = 0;
    this.totaliFase3AssegnateBando1 = 0;
    this.totaliFase3InCaricoBando1 = 0;
    this.totaliFase3InProgettazioneBando1 = 0;
    this.totaliFase3ConsegnateBando1 = 0;
    this.totaliFase3InVerificaSmartfiberBando1 = 0;
    this.totaliFase3InCaricoPresidioBando1 = 0; 
    this.totaliFase3InFirmaBando1 = 0;
    this.totaliFase3FirmateBando1 = 0;
    this.totaliFase3InReworkAziendaBando1 = 0;
    this.totaliFase3PubblicateBando1 = 0;
    this.totaliFase3ApprovateBando1 = 0;
    this.totaliFase3RespinteBando1 = 0;
  }

  resetTotaliFase3Bando2(){
    this.totaliFase3Bando2 = 0;
    this.totaliFase3DaAssegnareBando2 = 0;
    this.totaliFase3AssegnateBando2 = 0;
    this.totaliFase3InCaricoBando2 = 0;
    this.totaliFase3InProgettazioneBando2 = 0;
    this.totaliFase3ConsegnateBando2 = 0;
    this.totaliFase3InVerificaSmartfiberBando2 = 0;
    this.totaliFase3InCaricoPresidioBando2 = 0;
    this.totaliFase3InFirmaBando2 = 0;
    this.totaliFase3FirmateBando2 = 0;
    this.totaliFase3InReworkAziendaBando2 = 0;
    this.totaliFase3PubblicateBando2 = 0;
    this.totaliFase3ApprovateBando2 = 0;
    this.totaliFase3RespinteBando2 = 0;
  }

  openPraticheFase1(bando:number, statoFlowdyFase1:string){
    let statoFlowdy = statoFlowdyFase1;
    switch (statoFlowdyFase1) {
      case 'inAttesaODA':
        statoFlowdy = 'IN ATTESA ODA';
        break;
      case 'daAssegnare':
        statoFlowdy = 'DA ASSEGNARE';
        break;
      case 'assegnate':
        statoFlowdy = 'ASSEGNATA';
        break;
      case 'inCaricoImpresa':
        statoFlowdy = 'IN CARICO IMPRESA';
        break;
      case 'sopralluogoPianificato':
        statoFlowdy = 'SOPRALLUOGO PIANIFICATO';
        break;
      case 'sopralluogoEseguito':
        statoFlowdy = 'SOPRALLUOGO EFFETTUATO';
        break;
      case 'sopralluogoKO':
        statoFlowdy = 'SOPRALLUOGO KO';
        break;
      case 'preventivoInAttesa':
        statoFlowdy = 'PREVENTIVO IN ATTESA';
        break;
      case 'preventivoApprovato':
        statoFlowdy = 'PREVENTIVO APPROVATO';
        break;  
      case 'preventivoRifiutato':
        statoFlowdy = 'PREVENTIVO RIFIUTATO';
        break;
      case 'preventivoKO':
        statoFlowdy = 'PREVENTIVO KO';
        break;
      case 'consegnate':
        statoFlowdy = 'CONSEGNATA';
        break;
      case 'inVerificaSmartfiber':
        statoFlowdy = 'IN VERIFICA SMARTFIBER';
        break;
      case 'inReworkAzienda':
        statoFlowdy = 'IN REWORK AZIENDA';
        break;
      case 'inCaricoPresidio':
        statoFlowdy = 'IN CARICO PRESIDIO';
        break;
      case 'pubblicate':  
        statoFlowdy = 'PUBBLICATA';
        break;
      case 'approvate':
        statoFlowdy = 'APPROVATA';
        break;
      case 'respinte':  
        statoFlowdy = 'RESPINTA';
        break;
      default:
        statoFlowdy = statoFlowdyFase1;
        break;
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
      {
        queryParams: { 
          'stato-flowdy': statoFlowdy, 
          'from': 'DOCS_FASE1',
          ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
        }, 
      }
    ));
  }

  openPraticheFase2(bando:number, statoFlowdy:string){
    let statoFlowdyFase2 = statoFlowdy;
    switch (statoFlowdy) {
      
      case 'inAttesaODA':
        statoFlowdyFase2 = "IN ATTESA ODA";
        break;
      case 'daAssegnare':
        statoFlowdyFase2 = "DA ASSEGNARE";
        break;
      case 'assegnate':
        statoFlowdyFase2 = "ASSEGNATA";
        break;
      case 'inCaricoImpresa':
        statoFlowdyFase2 = "IN CARICO IMPRESA";
        break;
      case 'appuntamentoFissato':
        statoFlowdyFase2 = "APPUNTAMENTO FISSATO";
        break;
      case 'appuntamentoScaduto':
        statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        break;
      case 'installazioneOK':
        statoFlowdyFase2 = "INSTALLAZIONE OK";
        break;
      case 'attesaTS':
        statoFlowdyFase2 = "ATTESA TS";
        break;
      case 'attivazioneKO_CPE':
            statoFlowdyFase2 = "ATTIVAZIONE KO CPE";
        break;
      case 'attivazioneKO_FO':
        statoFlowdyFase2 = "ATTIVAZIONE KO FO";
        break;
      case 'attivazioneOK':
        statoFlowdyFase2 = "CONTROLLO TIM SUPPORT OK";
        break;
      case 'verificaTSKO':
        statoFlowdyFase2 = "CONTROLLO TIM SUPPORT KO";
        break;
      case 'consegnate':
        statoFlowdyFase2 = "CONSEGNATA";
        break;
      case 'inVerificaSmartfiber':
          statoFlowdyFase2 = "IN VERIFICA SMARTFIBER";
        break;
      case 'inReworkAzienda':
        statoFlowdyFase2 = "IN REWORK AZIENDA";
        break;  
      case 'inCaricoPresidio':
        statoFlowdyFase2 = "IN CARICO PRESIDIO";
        break;
      case 'pubblicate':
        statoFlowdyFase2 = "PUBBLICATA";
        break;
      case 'approvate':
        statoFlowdyFase2 = "APPROVATA";
        break;
      case 'respinte':
        statoFlowdyFase2 = "RESPINTA";
        break;
      default:
        statoFlowdyFase2 = statoFlowdy;
        break;
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
      {
        queryParams: { 
          'stato-flowdy': statoFlowdyFase2, 
          'from': 'DOCS_FASE2',
          ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
        }, 
      }
    ));
   
  }

  openPraticheFase3(bando:number, statoFlowdy:string){
    let statoFlowdyFase3 = statoFlowdy;
    switch (statoFlowdy) {
    
        case 'inAttesaODA':
          statoFlowdyFase3 = "IN ATTESA ODA";

          break;
        case 'daAssegnare':
          statoFlowdyFase3 = "DA ASSEGNARE";
          
          break;
        case 'assegnate':
          statoFlowdyFase3 = "ASSEGNATA";
          
          break;
        case 'inCaricoImpresa':
          statoFlowdyFase3 = "ASSEGNATA";
          
          break;
        case 'inProgettazione':
          statoFlowdyFase3 = "IN PROGETTAZIONE";
          
          break;
        case 'consegnate':
          statoFlowdyFase3 = "CONSEGNATA";
          
          break;
        case 'inVerificaSmartfiber':
          statoFlowdyFase3 = "IN VERIFICA SMARTFIBER";
          
          break;
        case 'inReworkAzienda':
            statoFlowdyFase3 = "IN REWORK AZIENDA";
          
          break;
        case 'inCaricoPresidio':
          statoFlowdyFase3 = "IN CARICO PRESIDIO";
          
          break;
        case 'pubblicate':
          statoFlowdyFase3 = "PUBBLICATA";
          
          break;
        case 'approvate':
          statoFlowdyFase3 = "APPROVATA";
          
          break;
        case 'respinte':
            statoFlowdyFase3 = "RESPINTA";
          
          break;
       
      default:
        statoFlowdyFase3 = statoFlowdy;
        break;
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
      {
        queryParams: { 
          'stato-flowdy': statoFlowdyFase3, 
          'from': 'DOCS_FASE3',
          ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
        }, 
      }
    ));
 
  }

  openPraticheFase1DiImpresa(bando:number, idImpresa:number,impresa:string,statoFlowdyFase1:string){
    switch (statoFlowdyFase1) {
      case 'ALL':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
              'impresa': idImpresa,
              'ragioneSocialeImpresa': impresa ,
              'from': 'DOCS_FASE1'
            }, 
          }
        ));
        break;
      case 'inAttesaODA':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN ATTESA ODA",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'daAssegnare':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "DA ASSEGNARE",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'assegnate':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "ASSEGNATA",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'inCaricoImpresa':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN CARICO IMPRESA",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'sopralluogoPianificato':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "SOPRALLUOGO PIANIFICATO",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'sopralluogoEseguito':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "SOPRALLUOGO EFFETTUATO",
                'from': 'DOCS_FASE1',
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'sopralluogoKO':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                        'from': 'DOCS_FASE1',
                'stato-flowdy': "SOPRALLUOGO KO", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'preventivoInAttesa':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "PREVENTIVO IN ATTESA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'preventivoApprovato':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "PREVENTIVO APPROVATO", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'preventivoRifiutato':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "PREVENTIVO RIFIUTATO", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})  
              }, 
          }
        ));
        break;
      case 'preventivoKO':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "PREVENTIVO KO", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'consegnate':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "CONSEGNATA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'inVerificaSmartfiber':  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "IN VERIFICA SMARTFIBER", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'inReworkAzienda':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "IN REWORK AZIENDA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'inCaricoPresidio':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "IN CARICO PRESIDIO", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'pubblicate':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "PUBBLICATA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'approvate':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "APPROVATA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
      case 'respinte':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
          {
            queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE1',
                'stato-flowdy': "RESPINTA", 
                ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
              }, 
          }
        ));
        break;
    }
   
  }

  openPraticheFase2DiImpresa(bando:number, idImpresa:number,impresa:string,statoFlowdy:string){
    switch (statoFlowdy) {
      case 'ALL':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
          {
            queryParams: { 
              'impresa': idImpresa,
              'ragioneSocialeImpresa': impresa ,
              'from': 'DOCS_FASE2',
            }, 
          }
        ));
        break;
        case 'inAttesaODA':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN ATTESA ODA",
                'from': 'DOCS_FASE2',
              }, 
            }
          ));
          break;
        case 'daAssegnare':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "DA ASSEGNARE",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'assegnate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "ASSEGNATA",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'inCaricoImpresa':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN CARICO IMPRESA",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'appuntamentoFissato':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "APPUNTAMENTO FISSATO",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'appuntamentoScaduto':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "APPUNTAMENTO MANCATO",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'installazioneOK':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "INSTALLAZIONE OK",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'attesaTS':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "ATTESA TS",
                'from': 'DOCS_FASE2',
              },  
            }
          ));
          break;
        case 'attivazioneKO_CPE':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE2',
                  'stato-flowdy': "ATTIVAZIONE KO CPE",
              },  
            }
          ));
          break;
        case 'attivazioneKO_FO':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {    
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'from': 'DOCS_FASE2',
                'stato-flowdy': "ATTIVAZIONE KO FO"  
              },  
            }
          ));
          break;
        case 'attivazioneOK':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "CONTROLLO TIM SUPPORT OK"  
              },  
            }
          ));
          break;
        case 'verificaTSKO':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "CONTROLLO TIM SUPPORT KO"  
              },  
            }
          ));
          break;
        case 'consegnate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "CONSEGNATA"  
              },  
            }
          ));
          break;
        case 'inVerificaSmartfiber':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "IN VERIFICA SMARTFIBER"  
              },  
            }
          ));
          break;
        case 'inReworkAzienda':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "IN REWORK AZIENDA"  
              },  
            }
          ));
          break;  
        case 'inCaricoPresidio':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "IN CARICO PRESIDIO"  
              },  
            }
          ));
          break;
        case 'pubblicate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "PUBBLICATA"  
              },  
            }
          ));
          break;
        case 'approvate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: {  
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,  
                'from': 'DOCS_FASE2',
                'stato-flowdy': "APPROVATA"  
              },  
            }
          ));
          break;
        
      default:
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
          {
            queryParams: { 'impresa': idImpresa }, 
          }
        ));
        break;
    }
  }
  
  openPraticheFase3DiImpresa(bando:number, idImpresa:number,impresa:string,statoFlowdy:string){
    switch (statoFlowdy) {
      case 'ALL':
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
          {
            queryParams: { 
              'impresa': idImpresa,
              'ragioneSocialeImpresa': impresa ,
              'from': 'DOCS_FASE3',
            }, 
          }
        ));
        break;
        case 'inAttesaODA':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN ATTESA ODA",
                'from': 'DOCS_FASE3',
              }, 
            }
          ));
          break;
        case 'daAssegnare':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "DA ASSEGNARE",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'assegnate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'], 
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "ASSEGNATA",
                'from': 'DOCS_FASE3',
              },    
            }
          ));
          break;
        case 'inCaricoImpresa':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "ASSEGNATA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'inProgettazione':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN PROGETTAZIONE",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'consegnate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "CONSEGNATA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'inVerificaSmartfiber':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN VERIFICA SMARTFIBER",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'inReworkAzienda':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "IN REWORK AZIENDA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'inCaricoPresidio':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                  'stato-flowdy': "IN CARICO PRESIDIO",
                  'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'pubblicate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "PUBBLICATA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'approvate':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                'stato-flowdy': "APPROVATA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
        case 'respinte':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
            {
              queryParams: { 
                'impresa': idImpresa ,
                'ragioneSocialeImpresa': impresa ,
                  'stato-flowdy': "RESPINTA",
                'from': 'DOCS_FASE3',
              },  
            }
          ));
          break;
       
      default:
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
          {
            queryParams: { 'impresa': idImpresa,
              'from': 'DOCS_FASE3',
            }, 
          }
        ));
        break;
    }
 
  }


  

  filtraPerRegione(selezione: string) {
    console.log(selezione);
    if(this.activeFasePanelIndex == 0){
      this.labelRegioni = "TUTTE LE REGIONI";
     
      if(this.activeBandoPanelIndex == 0){
        this.resetTotaliFase1Bando1();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase1Bando1Filtrati = [...this.datiRaggruppatiFase1Bando1];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase1Bando1();
        } else {
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
  
          this.datiRaggruppatiFase1Bando1Filtrati = this.datiRaggruppatiFase1Bando1.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.sopralluogoPianificato += regioneData.sopralluogoPianificato;
                acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
                acc.sopralluogoKO += regioneData.sopralluogoKO;
                acc.preventivoInAttesa += regioneData.preventivoInAttesa;
                acc.preventivoApprovato += regioneData.preventivoApprovato;
                acc.preventivoRifiutato += regioneData.preventivoRifiutato;
                acc.preventivoKO += regioneData.preventivoKO;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0,
                sopralluogoEseguito: 0,
                sopralluogoKO: 0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              sopralluogoPianificato: datiFiltratiPerRegione.sopralluogoPianificato,
              sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
              sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
              preventivoInAttesa: datiFiltratiPerRegione.preventivoInAttesa,
              preventivoApprovato: datiFiltratiPerRegione.preventivoApprovato,
              preventivoRifiutato: datiFiltratiPerRegione.preventivoRifiutato,
              preventivoKO: datiFiltratiPerRegione.preventivoKO,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);
          
            if(this.datiRaggruppatiFase1Bando1Filtrati.length > 0){
              this.caricaTotaliFase1Bando1();
            
          }
        }
      }else if(this.activeBandoPanelIndex == 1){
        this.resetTotaliFase1Bando2();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase1Bando2Filtrati = [...this.datiRaggruppatiFase1Bando2];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase1Bando2();
        } else {
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
  
          this.datiRaggruppatiFase1Bando2Filtrati = this.datiRaggruppatiFase1Bando2.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.sopralluogoPianificato += regioneData.sopralluogoPianificato;
                acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
                acc.sopralluogoKO += regioneData.sopralluogoKO;
                acc.preventivoInAttesa += regioneData.preventivoInAttesa;
                acc.preventivoApprovato += regioneData.preventivoApprovato;
                acc.preventivoRifiutato += regioneData.preventivoRifiutato;
                acc.preventivoKO += regioneData.preventivoKO;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                sopralluogoPianificato: 0,
                sopralluogoEseguito: 0,
                sopralluogoKO: 0,
                preventivoInAttesa: 0,
                preventivoApprovato: 0,
                preventivoRifiutato: 0,
                preventivoKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              sopralluogoPianificato: datiFiltratiPerRegione.sopralluogoPianificato,
              sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
              sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
              preventivoInAttesa: datiFiltratiPerRegione.preventivoInAttesa,
              preventivoApprovato: datiFiltratiPerRegione.preventivoApprovato,
              preventivoRifiutato: datiFiltratiPerRegione.preventivoRifiutato,
              preventivoKO: datiFiltratiPerRegione.preventivoKO,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);
          
          if(this.datiRaggruppatiFase1Bando2Filtrati.length > 0){
            this.caricaTotaliFase1Bando2();
          }
        }
      }
    }else if(this.activeFasePanelIndex == 1){
     
      if(this.activeBandoPanelIndex == 0){
        this.resetTotaliFase2Bando1();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase2Bando1Filtrati = [...this.datiRaggruppatiFase2Bando1];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase2Bando1();
        }else{
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
          this.datiRaggruppatiFase2Bando1Filtrati = this.datiRaggruppatiFase2Bando1.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.appuntamentoFissato += regioneData.appuntamentoFissato;
                acc.appuntamentoScaduto += regioneData.appuntamentoScaduto;
                acc.installazioneOK += regioneData.installazioneOK;
                acc.attesaTS += regioneData.attesaTS;
                acc.attivazioneKO_CPE += regioneData.attivazioneKO_CPE;
                acc.attivazioneKO_FO += regioneData.attivazioneKO_FO;
                acc.attivazioneOK += regioneData.attivazioneOK;
                acc.verificaTSKO += regioneData.verificaTSKO;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                installazioneOK: 0,
                attesaTS: 0,
                attivazioneKO_CPE: 0,
                attivazioneKO_FO: 0,
                attivazioneOK: 0,
                verificaTSKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              attesaTS: datiFiltratiPerRegione.attesaTS,
              attivazioneKO_CPE: datiFiltratiPerRegione.attivazioneKO_CPE,
              attivazioneKO_FO: datiFiltratiPerRegione.attivazioneKO_FO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              verificaTSKO: datiFiltratiPerRegione.verificaTSKO,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);

          if(this.datiRaggruppatiFase2Bando1Filtrati.length > 0){
            this.caricaTotaliFase2Bando1();
          }
        }
      }else if(this.activeBandoPanelIndex == 1){
        this.resetTotaliFase2Bando2();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase2Bando2Filtrati = [...this.datiRaggruppatiFase2Bando2];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase2Bando2();
        }else{
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
          this.datiRaggruppatiFase2Bando2Filtrati = this.datiRaggruppatiFase2Bando2.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.appuntamentoFissato += regioneData.appuntamentoFissato;
                acc.appuntamentoScaduto += regioneData.appuntamentoScaduto;
                acc.installazioneOK += regioneData.installazioneOK;
                acc.attesaTS += regioneData.attesaTS;
                acc.attivazioneKO_CPE += regioneData.attivazioneKO_CPE;
                acc.attivazioneKO_FO += regioneData.attivazioneKO_FO;
                acc.attivazioneOK += regioneData.attivazioneOK;
                acc.verificaTSKO += regioneData.verificaTSKO;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                installazioneOK: 0,
                attesaTS: 0,
                attivazioneKO_CPE: 0,
                attivazioneKO_FO: 0,
                attivazioneOK: 0,
                verificaTSKO: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              attesaTS: datiFiltratiPerRegione.attesaTS,
              attivazioneKO_CPE: datiFiltratiPerRegione.attivazioneKO_CPE,
              attivazioneKO_FO: datiFiltratiPerRegione.attivazioneKO_FO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              verificaTSKO: datiFiltratiPerRegione.verificaTSKO,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);


          if(this.datiRaggruppatiFase2Bando2Filtrati.length > 0){
            this.caricaTotaliFase2Bando2();
          }
        }

      }
    } else if(this.activeFasePanelIndex == 2){
      
      if(this.activeBandoPanelIndex == 0){
        this.resetTotaliFase3Bando1();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase3Bando1Filtrati = [...this.datiRaggruppatiFase3Bando1];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase3Bando1();
        }else{
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
          this.datiRaggruppatiFase3Bando1Filtrati = this.datiRaggruppatiFase3Bando1.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.inProgettazione += regioneData.inProgettazione;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.inFirma += regioneData.inFirma;
                acc.firmate += regioneData.firmate;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                inProgettazione: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
                inFirma: 0,
                firmate: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              inProgettazione: datiFiltratiPerRegione.inProgettazione,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              inFirma: datiFiltratiPerRegione.inFirma,
              firmate: datiFiltratiPerRegione.firmate,
                datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);

          if(this.datiRaggruppatiFase3Bando1Filtrati.length > 0){
            this.caricaTotaliFase3Bando1();
          }
        }
      }else if(this.activeBandoPanelIndex == 1){
        this.resetTotaliFase3Bando2();
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiFase3Bando2Filtrati = [...this.datiRaggruppatiFase3Bando2];
          this.labelRegioni = "TUTTE LE REGIONI";
          this.caricaTotaliFase3Bando2();
        }else{
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
          this.datiRaggruppatiFase3Bando2Filtrati = this.datiRaggruppatiFase3Bando2.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.inAttesaODA += regioneData.inAttesaODA;
                acc.daAssegnare += regioneData.daAssegnare;
                acc.assegnate += regioneData.assegnate;
                acc.inCaricoImpresa += regioneData.inCaricoImpresa;
                acc.inProgettazione += regioneData.inProgettazione;
                acc.consegnate += regioneData.consegnate;
                acc.inVerificaSmartfiber += regioneData.inVerificaSmartfiber;
                acc.inReworkAzienda += regioneData.inReworkAzienda;
                acc.inCaricoPresidio += regioneData.inCaricoPresidio;
                acc.inFirma += regioneData.inFirma;
                acc.firmate += regioneData.firmate;
                acc.pubblicate += regioneData.pubblicate;
                acc.approvate += regioneData.approvate;
                acc.respinte += regioneData.respinte;
                
                
                return acc;
              }, {
                totale: 0,
                inAttesaODA: 0,
                daAssegnare: 0,
                assegnate: 0,
                inCaricoImpresa: 0,
                inProgettazione: 0,
                consegnate: 0,
                inVerificaSmartfiber: 0,
                inReworkAzienda: 0,
                inCaricoPresidio: 0,
                pubblicate: 0,
                approvate: 0,
                respinte: 0,
                inFirma: 0,
                firmate: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              inAttesaODA: datiFiltratiPerRegione.inAttesaODA,
              daAssegnare: datiFiltratiPerRegione.daAssegnare,
              assegnate: datiFiltratiPerRegione.assegnate,
              inCaricoImpresa: datiFiltratiPerRegione.inCaricoImpresa,
              inProgettazione: datiFiltratiPerRegione.inProgettazione,
              consegnate: datiFiltratiPerRegione.consegnate,
              inVerificaSmartfiber: datiFiltratiPerRegione.inVerificaSmartfiber,
              inReworkAzienda: datiFiltratiPerRegione.inReworkAzienda,
              inCaricoPresidio: datiFiltratiPerRegione.inCaricoPresidio,
              pubblicate: datiFiltratiPerRegione.pubblicate,
              approvate: datiFiltratiPerRegione.approvate,
              respinte: datiFiltratiPerRegione.respinte,
              inFirma: datiFiltratiPerRegione.inFirma,
              firmate: datiFiltratiPerRegione.firmate,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);


          if(this.datiRaggruppatiFase3Bando2Filtrati.length > 0){
            this.caricaTotaliFase3Bando2();
          }
        }

      }
    } 
  }


  caricaTotaliFase1Bando1(){
    this.resetTotaliFase1Bando1();
    for (let index = 0; index < this.datiRaggruppatiFase1Bando1Filtrati.length; index++) {
      this.totaliFase1Bando1                       += this.datiRaggruppatiFase1Bando1Filtrati[index].totale;
      this.totaliFase1InAttesaODABando1            += this.datiRaggruppatiFase1Bando1Filtrati[index].inAttesaODA;
      this.totaliFase1DaAssegnareBando1            += this.datiRaggruppatiFase1Bando1Filtrati[index].daAssegnare;
      this.totaliFase1AssegnateBando1              += this.datiRaggruppatiFase1Bando1Filtrati[index].assegnate;
      this.totaliFase1InCaricoImpresaBando1        += this.datiRaggruppatiFase1Bando1Filtrati[index].inCaricoImpresa;
      this.totaliFase1SopralluogoPianificatoBando1 += this.datiRaggruppatiFase1Bando1Filtrati[index].sopralluogoPianificato;
      this.totaliFase1SopralluogoEseguitoBando1    += this.datiRaggruppatiFase1Bando1Filtrati[index].sopralluogoEseguito;
      this.totaliFase1SopralluogoKOBando1          += this.datiRaggruppatiFase1Bando1Filtrati[index].sopralluogoKO;
      this.totaliFase1PreventivoInAttesaBando1    += this.datiRaggruppatiFase1Bando1Filtrati[index].preventivoInAttesa;
      this.totaliFase1PreventivoApprovatoBando1   += this.datiRaggruppatiFase1Bando1Filtrati[index].preventivoApprovato;
      this.totaliFase1PreventivoRifiutatoBando1   += this.datiRaggruppatiFase1Bando1Filtrati[index].preventivoRifiutato;
      this.totaliFase1PreventivoKOBando1          += this.datiRaggruppatiFase1Bando1Filtrati[index].preventivoKO;
      this.totaliFase1ConsegnateBando1            += this.datiRaggruppatiFase1Bando1Filtrati[index].consegnate;
      this.totaliFase1InVerificaSmartfiberBando1  += this.datiRaggruppatiFase1Bando1Filtrati[index].inVerificaSmartfiber;
      this.totaliFase1InReworkAziendaBando1       += this.datiRaggruppatiFase1Bando1Filtrati[index].inReworkAzienda;
      this.totaliFase1InCaricoPresidioBando1      += this.datiRaggruppatiFase1Bando1Filtrati[index].inCaricoPresidio;
      this.totaliFase1PubblicateBando1           += this.datiRaggruppatiFase1Bando1Filtrati[index].pubblicate;
      this.totaliFase1ApprovateBando1            += this.datiRaggruppatiFase1Bando1Filtrati[index].approvate;
      this.totaliFase1RespinteBando1             += this.datiRaggruppatiFase1Bando1Filtrati[index].respinte;
        
    }
  }

  caricaTotaliFase2Bando1(){
    this.resetTotaliFase2Bando1();
    for (let index = 0; index < this.datiRaggruppatiFase2Bando1Filtrati.length; index++) {
      this.totaliFase2Bando1                  += this.datiRaggruppatiFase2Bando1Filtrati[index].totale;
      this.totaliFase2InAttesaODABando1         += this.datiRaggruppatiFase2Bando1Filtrati[index].inAttesaODA;
      this.totaliFase2DaAssegnareBando1         += this.datiRaggruppatiFase2Bando1Filtrati[index].daAssegnare;
      this.totaliFase2AssegnateBando1           += this.datiRaggruppatiFase2Bando1Filtrati[index].assegnate;
      this.totaliFase2InCaricoImpresaBando1     += this.datiRaggruppatiFase2Bando1Filtrati[index].inCaricoImpresa;
      this.totaliFase2AppuntamentoFissatoBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].appuntamentoFissato;
      this.totaliFase2AppuntamentoScadutoBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].appuntamentoScaduto;
      this.totaliFase2InstallazioneOKBando1     += this.datiRaggruppatiFase2Bando1Filtrati[index].installazioneOK;
      this.totaliFase2AttesaTSBando1            += this.datiRaggruppatiFase2Bando1Filtrati[index].attesaTS;
      this.totaliFase2AttivazioneKO_CPEBando1   += this.datiRaggruppatiFase2Bando1Filtrati[index].attivazioneKO_CPE;
      this.totaliFase2AttivazioneKO_FOBando1    += this.datiRaggruppatiFase2Bando1Filtrati[index].attivazioneKO_FO;
      this.totaliFase2VerificaTSKO_Bando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].verificaTSKO;
      this.totaliFase2AttivazioneOKBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].attivazioneOK;
      this.totaliFase2ConsegnateBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].consegnate;
      this.totaliFase2InVerificaSmartfiberBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].inVerificaSmartfiber;
      this.totaliFase2InReworkAziendaBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].inReworkAzienda;
      this.totaliFase2InCaricoPresidioBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].inCaricoPresidio;
      this.totaliFase2PubblicateBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].pubblicate;
      this.totaliFase2ApprovateBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].approvate;
      this.totaliFase2RespinteBando1 += this.datiRaggruppatiFase2Bando1Filtrati[index].respinte;
      
    }
  }

  caricaTotaliFase2Bando2(){
    this.resetTotaliFase2Bando2();
    for (let index = 0; index < this.datiRaggruppatiFase2Bando2Filtrati.length; index++) {
      this.totaliFase2Bando2                      += this.datiRaggruppatiFase2Bando2Filtrati[index].totale;
      this.totaliFase2InAttesaODABando2           += this.datiRaggruppatiFase2Bando2Filtrati[index].inAttesaODA;
      this.totaliFase2DaAssegnareBando2           += this.datiRaggruppatiFase2Bando2Filtrati[index].daAssegnare;
      this.totaliFase2AssegnateBando2             += this.datiRaggruppatiFase2Bando2Filtrati[index].assegnate;
      this.totaliFase2InCaricoImpresaBando2       += this.datiRaggruppatiFase2Bando2Filtrati[index].inCaricoImpresa;
      this.totaliFase2AppuntamentoFissatoBando2   += this.datiRaggruppatiFase2Bando2Filtrati[index].appuntamentoFissato;
      this.totaliFase2AppuntamentoScadutoBando2   += this.datiRaggruppatiFase2Bando2Filtrati[index].appuntamentoScaduto;
      this.totaliFase2InstallazioneOKBando2       += this.datiRaggruppatiFase2Bando2Filtrati[index].installazioneOK;
      this.totaliFase2AttesaTSBando2              += this.datiRaggruppatiFase2Bando2Filtrati[index].attesaTS;
      this.totaliFase2AttivazioneKO_CPEBando2     += this.datiRaggruppatiFase2Bando2Filtrati[index].attivazioneKO_CPE;
      this.totaliFase2AttivazioneKO_FOBando2      += this.datiRaggruppatiFase2Bando2Filtrati[index].attivazioneKO_FO;
      this.totaliFase2VerificaTSKO_Bando2         += this.datiRaggruppatiFase2Bando2Filtrati[index].verificaTSKO;
      this.totaliFase2AttivazioneOKBando2         += this.datiRaggruppatiFase2Bando2Filtrati[index].attivazioneOK;
      this.totaliFase2ConsegnateBando2            += this.datiRaggruppatiFase2Bando2Filtrati[index].consegnate;
      this.totaliFase2InVerificaSmartfiberBando2  += this.datiRaggruppatiFase2Bando2Filtrati[index].inVerificaSmartfiber;
      this.totaliFase2InReworkAziendaBando2       += this.datiRaggruppatiFase2Bando2Filtrati[index].inReworkAzienda;
      this.totaliFase2InCaricoPresidioBando2      += this.datiRaggruppatiFase2Bando2Filtrati[index].inCaricoPresidio;
      this.totaliFase2PubblicateBando2            += this.datiRaggruppatiFase2Bando2Filtrati[index].pubblicate;
      this.totaliFase2ApprovateBando2             += this.datiRaggruppatiFase2Bando2Filtrati[index].approvate;
      this.totaliFase2RespinteBando2              += this.datiRaggruppatiFase2Bando2Filtrati[index].respinte;
      

    }
  }

  caricaTotaliFase3Bando1(){
    this.resetTotaliFase3Bando1();
    for (let index = 0; index < this.datiRaggruppatiFase3Bando1Filtrati.length; index++) {
      this.totaliFase3Bando1                      += this.datiRaggruppatiFase3Bando1Filtrati[index].totale;
      this.totaliFase3InAttesaODABando1           += this.datiRaggruppatiFase3Bando1Filtrati[index].inAttesaODA;
      this.totaliFase3DaAssegnareBando1           += this.datiRaggruppatiFase3Bando1Filtrati[index].daAssegnare;
      this.totaliFase3AssegnateBando1             += this.datiRaggruppatiFase3Bando1Filtrati[index].assegnate;
      this.totaliFase3InCaricoBando1              += this.datiRaggruppatiFase3Bando1Filtrati[index].inCaricoImpresa;
      this.totaliFase3InProgettazioneBando1       += this.datiRaggruppatiFase3Bando1Filtrati[index].inProgettazione;
      this.totaliFase3ConsegnateBando1            += this.datiRaggruppatiFase3Bando1Filtrati[index].consegnate;
      this.totaliFase3InVerificaSmartfiberBando1  += this.datiRaggruppatiFase3Bando1Filtrati[index].inVerificaSmartfiber;
      this.totaliFase3InCaricoPresidioBando1      += this.datiRaggruppatiFase3Bando1Filtrati[index].inCaricoPresidio;
      this.totaliFase3InFirmaBando1               += this.datiRaggruppatiFase3Bando1Filtrati[index].inFirma;
      this.totaliFase3FirmateBando1               += this.datiRaggruppatiFase3Bando1Filtrati[index].firmate;
      this.totaliFase3InReworkAziendaBando1       += this.datiRaggruppatiFase3Bando1Filtrati[index].inReworkAzienda;
      this.totaliFase3PubblicateBando1            += this.datiRaggruppatiFase3Bando1Filtrati[index].pubblicate;
      this.totaliFase3ApprovateBando1             += this.datiRaggruppatiFase3Bando1Filtrati[index].approvate;
      this.totaliFase3RespinteBando1              += this.datiRaggruppatiFase3Bando1Filtrati[index].respinte;
      
    }
  }

  caricaTotaliFase3Bando2(){
    this.resetTotaliFase3Bando2();
    for (let index = 0; index < this.datiRaggruppatiFase3Bando2Filtrati.length; index++) {
      this.totaliFase3Bando2                      += this.datiRaggruppatiFase3Bando2Filtrati[index].totale;
      this.totaliFase3InAttesaODABando2          += this.datiRaggruppatiFase3Bando2Filtrati[index].inAttesaODA;
      this.totaliFase3DaAssegnareBando2          += this.datiRaggruppatiFase3Bando2Filtrati[index].daAssegnare;
      this.totaliFase3AssegnateBando2             += this.datiRaggruppatiFase3Bando2Filtrati[index].assegnate;
      this.totaliFase3InCaricoBando2              += this.datiRaggruppatiFase3Bando2Filtrati[index].inCaricoImpresa;
      this.totaliFase3InProgettazioneBando2       += this.datiRaggruppatiFase3Bando2Filtrati[index].inProgettazione;
      this.totaliFase3ConsegnateBando2            += this.datiRaggruppatiFase3Bando2Filtrati[index].consegnate;
      this.totaliFase3InVerificaSmartfiberBando2  += this.datiRaggruppatiFase3Bando2Filtrati[index].inVerificaSmartfiber;
      this.totaliFase3InCaricoPresidioBando2      += this.datiRaggruppatiFase3Bando2Filtrati[index].inCaricoPresidio;
      this.totaliFase3InFirmaBando2               += this.datiRaggruppatiFase3Bando2Filtrati[index].inFirma;
      this.totaliFase3FirmateBando2               += this.datiRaggruppatiFase3Bando2Filtrati[index].firmate;
      this.totaliFase3InReworkAziendaBando2       += this.datiRaggruppatiFase3Bando2Filtrati[index].inReworkAzienda;
      this.totaliFase3PubblicateBando2            += this.datiRaggruppatiFase3Bando2Filtrati[index].pubblicate;
      this.totaliFase3ApprovateBando2             += this.datiRaggruppatiFase3Bando2Filtrati[index].approvate;
      this.totaliFase3RespinteBando2              += this.datiRaggruppatiFase3Bando2Filtrati[index].respinte;
      
    }
  }


  caricaTotaliFase1Bando2(){
    this.resetTotaliFase1Bando2();
    for (let index = 0; index < this.datiRaggruppatiFase1Bando2Filtrati.length; index++) {
      this.totaliFase1Bando2                       += this.datiRaggruppatiFase1Bando2Filtrati[index].totale;
      this.totaliFase1InAttesaODABando2            += this.datiRaggruppatiFase1Bando2Filtrati[index].inAttesaODA;
      this.totaliFase1DaAssegnareBando2            += this.datiRaggruppatiFase1Bando2Filtrati[index].daAssegnare;
      this.totaliFase1AssegnateBando2              += this.datiRaggruppatiFase1Bando2Filtrati[index].assegnate;
      this.totaliFase1InCaricoImpresaBando2        += this.datiRaggruppatiFase1Bando2Filtrati[index].inCaricoImpresa;
      this.totaliFase1SopralluogoPianificatoBando2 += this.datiRaggruppatiFase1Bando2Filtrati[index].sopralluogoPianificato;
      this.totaliFase1SopralluogoEseguitoBando2    += this.datiRaggruppatiFase1Bando2Filtrati[index].sopralluogoEseguito;
      this.totaliFase1SopralluogoKOBando2          += this.datiRaggruppatiFase1Bando2Filtrati[index].sopralluogoKO;
      this.totaliFase1PreventivoInAttesaBando2     += this.datiRaggruppatiFase1Bando2Filtrati[index].preventivoInAttesa;
      this.totaliFase1PreventivoApprovatoBando2    += this.datiRaggruppatiFase1Bando2Filtrati[index].preventivoApprovato;
      this.totaliFase1PreventivoRifiutatoBando2    += this.datiRaggruppatiFase1Bando2Filtrati[index].preventivoRifiutato;
      this.totaliFase1PreventivoKOBando2           += this.datiRaggruppatiFase1Bando2Filtrati[index].preventivoKO;
      this.totaliFase1ConsegnateBando2             += this.datiRaggruppatiFase1Bando2Filtrati[index].consegnate;
      this.totaliFase1InVerificaSmartfiberBando2   += this.datiRaggruppatiFase1Bando2Filtrati[index].inVerificaSmartfiber;
      this.totaliFase1InReworkAziendaBando2        += this.datiRaggruppatiFase1Bando2Filtrati[index].inReworkAzienda;
      this.totaliFase1InCaricoPresidioBando2       += this.datiRaggruppatiFase1Bando2Filtrati[index].inCaricoPresidio;
      this.totaliFase1PubblicateBando2             += this.datiRaggruppatiFase1Bando2Filtrati[index].pubblicate;
      this.totaliFase1ApprovateBando2              += this.datiRaggruppatiFase1Bando2Filtrati[index].approvate;
      this.totaliFase1RespinteBando2                += this.datiRaggruppatiFase1Bando2Filtrati[index].respinte;
      
    }
  }
  

  removeFilter() {
    this.filterIsSet = false;
    this.filtroRegione = [];
    if(this.activeFasePanelIndex == 0){
      this.labelRegioni = "TUTTE LE REGIONI";
      if(this.activeBandoPanelIndex == 0){
         this.datiRaggruppatiFase1Bando1Filtrati = [...this.datiRaggruppatiFase1Bando1];
         this.caricaTotaliFase1Bando1();
      }else if(this.activeBandoPanelIndex == 1){
        this.datiRaggruppatiFase1Bando2Filtrati = [...this.datiRaggruppatiFase1Bando2];
        this.caricaTotaliFase1Bando2();
      }
     
    }else if(this.activeFasePanelIndex == 1){
      this.labelRegioni = "TUTTE LE REGIONI";
      if(this.activeBandoPanelIndex == 0){
         this.datiRaggruppatiFase2Bando1Filtrati = [...this.datiRaggruppatiFase2Bando1];
         this.caricaTotaliFase2Bando1();
      }else if(this.activeBandoPanelIndex == 1){
        this.datiRaggruppatiFase2Bando2Filtrati = [...this.datiRaggruppatiFase2Bando2];
        this.caricaTotaliFase2Bando2();
      }
    } else if(this.activeFasePanelIndex == 2){
      this.labelRegioni = "TUTTE LE REGIONI";
      if(this.activeBandoPanelIndex == 0){
        this.datiRaggruppatiFase3Bando1Filtrati = [...this.datiRaggruppatiFase3Bando1];
        this.caricaTotaliFase3Bando1();
      }else if(this.activeBandoPanelIndex == 1){
        this.datiRaggruppatiFase3Bando2Filtrati = [...this.datiRaggruppatiFase3Bando2];
        this.caricaTotaliFase3Bando2();
      }
    } 
  }

  
  scaricaReport() {
    if(this.activeFasePanelIndex == 0){
      if(this.activeBandoPanelIndex == 0){
        this.excelService.exportDocFase1ToExcel(this.datiRaggruppatiFase1Bando1Filtrati, 'Report_Doc_Fase1_Bando_1');
      }else if(this.activeBandoPanelIndex == 1){
        this.excelService.exportDocFase1ToExcel(this.datiRaggruppatiFase1Bando2Filtrati, 'Report_Doc_Fase1_Bando_2');
      }
    }else if(this.activeFasePanelIndex == 1){
      if(this.activeBandoPanelIndex == 0){
        this.excelService.exportDocFase2ToExcel(this.datiRaggruppatiFase2Bando1Filtrati, 'Report_Doc_Fase2_Bando_1');
      }else if(this.activeBandoPanelIndex == 1){
        this.excelService.exportDocFase2ToExcel(this.datiRaggruppatiFase2Bando2Filtrati, 'Report_Doc_Fase2_Bando_2');
      }
    }else if(this.activeFasePanelIndex == 2){
      if(this.activeBandoPanelIndex == 0){
        this.excelService.exportDocFase3ToExcel(this.datiRaggruppatiFase3Bando1Filtrati, 'Report_Doc_Fase3_Bando_1');
      }else if(this.activeBandoPanelIndex == 1){
        this.excelService.exportDocFase3ToExcel(this.datiRaggruppatiFase3Bando2Filtrati, 'Report_Doc_Fase3_Bando_2');
      }
    }
  }

  /**
   * Reset di tutti i flags di caricamento
   */
  private resetLoadingFlags() {
    this.fase1Bando1Loaded = false;
    this.fase1Bando2Loaded = false;
    this.fase2Bando1Loaded = false;
    this.fase2Bando2Loaded = false;
    this.fase3Bando1Loaded = false;
    this.fase3Bando2Loaded = false;
  }

  /**
   * Imposta i tab attivi basandosi sui parametri di input (input properties)
   */
  private setActiveTabsFromInputs() {
    let shouldForceLoad = false;
    let faseIndexChanged = false;
    let bandoIndexChanged = false;
    
    // Imposta il bando prima
    if (this.activeBandoNumber !== undefined && this.activeBandoNumber !== null) {
      const oldBandoIndex = this.activeBandoPanelIndex;
      // Converti esplicitamente in numero per evitare problemi di tipo
      const bandoNumber = Number(this.activeBandoNumber);
      this.activeBandoPanelIndex = bandoNumber === 1 ? 0 : bandoNumber === 2 ? 1 : 0;
      bandoIndexChanged = oldBandoIndex !== this.activeBandoPanelIndex;
      shouldForceLoad = true;
    }
    
    // Imposta il tipo di fase (DOCS_FASE1, DOCS_FASE2, DOCS_FASE3)
    if (this.activeTabType !== undefined && this.activeTabType !== null) {
      const oldFaseIndex = this.activeFasePanelIndex;
      switch (this.activeTabType) {
        case 'DOCS_FASE1':
          this.activeFasePanelIndex = 0;
          break;
        case 'DOCS_FASE2':
          this.activeFasePanelIndex = 1;
          break;
        case 'DOCS_FASE3':
          this.activeFasePanelIndex = 2;
          break;
        default:
          this.activeFasePanelIndex = 0; // Default a Fase 1
      }
      faseIndexChanged = oldFaseIndex !== this.activeFasePanelIndex;
      shouldForceLoad = true;
    } else if (this.activeBandoNumber !== undefined && this.activeBandoNumber !== null) {
      // Se activeBandoNumber è impostato ma activeTabType no, usa il default (Fase 1)
      const oldFaseIndex = this.activeFasePanelIndex;
      this.activeFasePanelIndex = 0; // Default a Fase 1
      faseIndexChanged = oldFaseIndex !== this.activeFasePanelIndex;
      shouldForceLoad = true;
    }
    
    // Carica i dati del tab selezionato, forzando SOLO se c'è un cambiamento reale dei tab
    if (shouldForceLoad && (faseIndexChanged || bandoIndexChanged)) {
      this.loadActiveTabData(true);
    } else if (shouldForceLoad) {
      this.loadActiveTabData();
    } else {
      this.loadActiveTabData();
    }
  }

  /**
   * Carica i dati per il tab attualmente attivo
   * @param forceLoad Se true, forza il caricamento anche se i dati sono già stati caricati
   */
  private loadActiveTabData(forceLoad: boolean = false) {
    if (this.activeFasePanelIndex === 0) { // Fase 1
      if (this.activeBandoPanelIndex === 0 && (!this.fase1Bando1Loaded || forceLoad) && !this.isLoadingFase1Bando1) {
        this.loadDatiFase1Bando1();
      } else if (this.activeBandoPanelIndex === 1 && (!this.fase1Bando2Loaded || forceLoad) && !this.isLoadingFase1Bando2) {
        this.loadDatiFase1Bando2();
      }
    } else if (this.activeFasePanelIndex === 1) { // Fase 2
      if (this.activeBandoPanelIndex === 0 && (!this.fase2Bando1Loaded || forceLoad) && !this.isLoadingFase2Bando1) {
        this.loadDatiFase2Bando1();
      } else if (this.activeBandoPanelIndex === 1 && (!this.fase2Bando2Loaded || forceLoad) && !this.isLoadingFase2Bando2) {
        this.loadDatiFase2Bando2();
      }
    } else if (this.activeFasePanelIndex === 2) { // Fase 3
      if (this.activeBandoPanelIndex === 0 && (!this.fase3Bando1Loaded || forceLoad) && !this.isLoadingFase3Bando1) {
        this.loadDatiFase3Bando1();
      } else if (this.activeBandoPanelIndex === 1 && (!this.fase3Bando2Loaded || forceLoad) && !this.isLoadingFase3Bando2) {
        this.loadDatiFase3Bando2();
      }
    }
  }
} 
